{
  "title": "الإعدادات",
  "subtitle": "طريقة إعداد الشركة: هويتها ومستنداتها المطبوعة والقواعد التي تسير عليها دفاترها.",
  "search": {
    "label": "البحث في الإعدادات",
    "placeholder": "ابحث في الإعدادات…",
    "clear": "مسح البحث",
    "empty": "لا يوجد إعداد يطابق «{{query}}». جرّب كلمة أخرى، مثل الضريبة أو الشعار أو البنك.",
    "found_zero": "لا توجد نتائج",
    "found_one": "نتيجة واحدة",
    "found_two": "نتيجتان",
    "found_few": "{{n}} نتائج",
    "found_many": "{{n}} نتيجة",
    "found_other": "{{n}} نتيجة"
  },
  "rail": {
    "label": "أقسام الإعدادات",
    "unsaved": "تغييرات غير محفوظة",
    "opensPage": "(تفتح صفحتها)",
    "back": "العودة إلى كل الإعدادات"
  },
  "groups": {
    "personal": "أنت",
    "company": "الشركة",
    "documents": "المستندات",
    "salesPurchasing": "المبيعات والمشتريات",
    "inventory": "المخزون",
    "accounting": "المحاسبة",
    "work": "العمل",
    "communication": "التواصل",
    "automation": "الأتمتة ومسارات العمل",
    "administration": "الإدارة"
  },
  "sections": {
    "appearance": {
      "title": "المظهر",
      "intro": "شكل سحاب لك على هذا المتصفح. تُطبَّق التغييرات فور اختيارها."
    },
    "company": {
      "title": "ملف الشركة",
      "intro": "الاسم الذي يظهر في التطبيق، والهوية القانونية التي تُطبع في رأس كل مستند."
    },
    "typography": {
      "title": "الخطوط والنص",
      "intro": "نوع الخط وحجم النص في كل الشاشات، لجميع مستخدمي الشركة. المستندات المطبوعة تحتفظ بخطها."
    },
    "printing": {
      "title": "الطباعة",
      "intro": "ما يُطبع في أسفل الفواتير وسائر المستندات: التذييل والشروط وطريقة الدفع لك والمشاركة."
    },
    "numbering": {
      "title": "الترقيم",
      "intro": "كيف يُرقَّم كل نوع من المستندات، والرقم الذي يأخذه المستند التالي."
    },
    "defaults": {
      "title": "القيم الافتراضية",
      "intro": "ما تبدأ به مستندات المبيعات والمشتريات الجديدة. تحتفظ المستندات المحفوظة بقيمها."
    },
    "payment-methods": {
      "title": "طرق الدفع",
      "intro": "طرق الدفع التي تستلم بها شركتك وتدفع بها (فيزا، ثواني، التحويلات البنكية) وحساب النقدية أو البنك الذي تبدأ به كل منها في سندات القبض والاستردادات ومدفوعات الموردين."
    },
    "tax-rates": {
      "title": "نسب الضريبة",
      "intro": "ضريبة القيمة المضافة وغيرها من النسب المتاحة في المستندات؛ تُستخدم النسبة الافتراضية في البنود الجديدة."
    },
    "stock-policy": {
      "title": "سياسة المخزون",
      "intro": "ما يحدث حين تُنزل عملية بيعٍ المخزونَ إلى ما دون الصفر، عند ترحيل الفاتورة وفي شاشة البيع."
    },
    "account-mapping": {
      "title": "ربط الحسابات",
      "intro": "الحساب الذي يستخدمه كل نوع من القيود. تُرحَّل المستندات إلى هذه الحسابات تلقائيًا."
    },
    "lock-date": {
      "title": "تاريخ الإقفال",
      "intro": "يُقفل الدفاتر حتى تاريخ معيّن: لا يمكن ترحيل أو تعديل أي شيء مؤرخ فيه أو قبله."
    },
    "accounting-checks": {
      "title": "فحوص الدفاتر",
      "intro": "أي فحوص سلامة الدفاتر تعمل، ومتى ينبّه كل منها."
    },
    "tasks": {
      "title": "المهام",
      "intro": "كيف تُراجَع المهام ويُعاد تحديد مواعيدها، ومتى يُبلَّغ قادة الفرق بالأعمال المتأخرة."
    },
    "service": {
      "title": "أوامر الخدمة",
      "intro": "متى يسجّل الفنيون العمل، وما يلزم تقرير الزيارة قبل إنهائها."
    },
    "service-site-templates": {
      "title": "قوالب المواقع",
      "intro": "كيف تُسمّى أماكن موقع العميل مستوىً بعد مستوى: الطابق ‹ الشقة، المستوى ‹ المحل. يختار كل موقع قالبه."
    },
    "service-asset-types": {
      "title": "أنواع المعدات",
      "intro": "أنواع المعدات التي تصونها الشركة، ولكل نوع بياناته وقائمة فحصه وبادئة رمزه التعريفي وفترة صيانته المعتادة."
    },
    "contracts": {
      "title": "عقود الصيانة",
      "intro": "متى يُذكَّر بتجديد العقود، ومتى تصبح الزيارات الوقائية أوامر خدمة، وما يبدأ به عقد الصيانة الجديد."
    },
    "projects": {
      "title": "المشاريع",
      "intro": "الوظائف المتاحة للمشاريع، والنوع الذي يبدأ منه المشروع الجديد، وطريقة قياس الإنجاز للمشروع الذي ليس له نوع."
    },
    "project-types": {
      "title": "أنواع المشاريع",
      "intro": "أنواع المشاريع التي تنفذها الشركة، ولكل نوع وظائفه وطريقة فوترته وقالب خطة مؤرخ بأيام العمل."
    },
    "calendar": {
      "title": "تقويم العمل",
      "intro": "أسبوع العمل والعطل الرسمية للشركة. تتخطى مواعيد الاستحقاق ومؤقتات الموافقات المحسوبة بأيام العمل أيام العطل."
    },
    "organization": {
      "title": "الهيكل التنظيمي",
      "intro": "شجرة الوحدات التنظيمية: كل وحدة تحت الوحدة التي تتبعها، ورؤساؤها والرؤساء بالإنابة وشركاء الموارد البشرية. تتبعها الموافقات وتحدد من يرى أي السجلات."
    },
    "work-locations": {
      "title": "مواقع العمل",
      "intro": "المكاتب والمواقع التي يعمل فيها الموظفون، حسب المحافظة والولاية. تعتمد كل وحدة أحدها موقعًا افتراضيًا."
    },
    "teams": {
      "title": "الفرق",
      "intro": "أشخاص مجمّعون مع قادتهم. الفرق تتولى المهام وتنفّذ زيارات الخدمة، أيًّا كانت الوحدات التي تستخدمها الشركة."
    },
    "privacy": {
      "title": "الخصوصية",
      "intro": "مدة الاحتفاظ بالبيانات الشخصية ضمن الحدود النظامية، وسجل المعالجة."
    },
    "legal-holds": {
      "title": "الحجز القانوني",
      "intro": "سجلات مستثناة من الاحتفاظ ما دام هناك نزاع أو تدقيق أو مطالبة قائمة."
    },
    "notifications": {
      "title": "المراسلة",
      "intro": "من يُرسل رسائل البريد إلى العملاء، وإلى أين تصل الردود، وأي خدمة بريد ترسلها."
    },
    "ai": {
      "title": "المساعد الذكي",
      "intro": "المساعد الذي يعمل بمفتاح OpenAI الخاص بشركتك: تشغيله، والمفتاح، والنموذج، والحدود، والميزات، ومدة الاحتفاظ بالمحادثات."
    },
    "modules": {
      "title": "الوحدات",
      "intro": "أجزاء سحاب ERP التي تستخدمها شركتك."
    },
    "regional": {
      "title": "الإعدادات الإقليمية",
      "intro": "طريقة كتابة التواريخ والأرقام والمبالغ في كل مكان من التطبيق وفي المستندات."
    },
    "system": {
      "title": "معلومات النظام",
      "intro": "إصدار التطبيق الحالي، وأين تجد المساعدة."
    },
    "project-cost-categories": {
      "title": "فئات التكاليف",
      "intro": "كيف تُجمّع تكاليف المشاريع وتُوازن، والحساب الذي تُرحّل إليه كل فئة، وأي فئة تأخذها التكلفة عند عدم اختيار فئة."
    },
    "project-insights": {
      "title": "مؤشرات المشاريع",
      "intro": "متى تتحول سلامة المشروع إلى الأصفر أو الأحمر: حد كل تنبيه بكلمات واضحة، وطريقة حساب التكلفة النهائية المتوقعة."
    },
    "project-contracting": {
      "title": "المقاولات",
      "intro": "الشروط التي يبدأ منها كل عقد جديد: طريقة قياس الأعمال، وموعد سداد المستخلصات، والمحتجزات، والدفعة المقدمة، وغرامات التأخير."
    },
    "project-rate-roles": {
      "title": "أدوار التسعير",
      "intro": "الأدوار التي يُفوتر بها وقت الأشخاص، مثل مهندس موقع أو مستشار، ولكل دور سعر فوترة للساعة."
    },
    "commissions": {
      "title": "العمولات",
      "intro": "من يعتمد كشف العمولات، وهل تُصرف العمولة المعتمدة في قسيمة الراتب."
    }
  },
  "links": {
    "tills": {
      "label": "الصناديق",
      "status_zero": "لا يوجد صندوق نشط",
      "status_one": "صندوق نشط واحد",
      "status_two": "صندوقان نشطان",
      "status_few": "{{n}} صناديق نشطة",
      "status_many": "{{n}} صندوقًا نشطًا",
      "status_other": "{{n}} صندوق نشط"
    },
    "warehouses": {
      "label": "المستودعات",
      "status_zero": "لا يوجد مستودع",
      "status_one": "مستودع واحد",
      "status_two": "مستودعان",
      "status_few": "{{n}} مستودعات",
      "status_many": "{{n}} مستودعًا",
      "status_other": "{{n}} مستودع"
    },
    "fiscalYears": {
      "label": "السنوات المالية",
      "open": "{{name}} مفتوحة",
      "closed": "{{name}} مُقفلة",
      "none": "لا توجد سنة بعد"
    },
    "cashBank": {
      "label": "النقدية والبنوك",
      "status_zero": "لا يوجد حساب",
      "status_one": "حساب واحد",
      "status_two": "حسابان",
      "status_few": "{{n}} حسابات",
      "status_many": "{{n}} حسابًا",
      "status_other": "{{n}} حساب"
    },
    "users": {
      "label": "المستخدمون",
      "status_zero": "لا يوجد مستخدم نشط",
      "status_one": "مستخدم نشط واحد",
      "status_two": "مستخدمان نشطان",
      "status_few": "{{n}} مستخدمين نشطين",
      "status_many": "{{n}} مستخدمًا نشطًا",
      "status_other": "{{n}} مستخدم نشط"
    },
    "roles": {
      "label": "الأدوار",
      "status_zero": "لا يوجد دور",
      "status_one": "دور واحد",
      "status_two": "دوران",
      "status_few": "{{n}} أدوار",
      "status_many": "{{n}} دورًا",
      "status_other": "{{n}} دور"
    },
    "auditLog": {
      "label": "سجل التدقيق",
      "status": "من غيّر ماذا، ومتى"
    },
    "workflows": {
      "label": "مسارات الاعتماد",
      "status": "أي المشتريات تحتاج إلى اعتماد، ومن يعتمدها"
    },
    "workflowRuns": {
      "label": "طلبات الاعتماد",
      "status": "الطلبات الجارية أو المتوقفة أو المتعثرة"
    },
    "delegations": {
      "label": "التفويضات",
      "status": "من يعتمد نيابةً عن من أثناء الغياب"
    },
    "messageTemplates": {
      "label": "قوالب الرسائل",
      "status": "صياغة الرسائل التي تصل إلى العملاء"
    },
    "messageOutbox": {
      "label": "صندوق الصادر",
      "status": "ما أُرسل، وما تعذّر إرساله ولماذا"
    },
    "loyalty": {
      "label": "برنامج الولاء",
      "status": "الكسب والاستبدال والمستويات وقواعد المكافآت"
    },
    "payComponents": {
      "label": "عناصر الراتب",
      "status": "هيكل الرواتب: الأساسي والبدلات والاستقطاعات"
    },
    "contributionRules": {
      "label": "نسب الاشتراكات",
      "status": "نسب صندوق الحماية الاجتماعية لكل فرع"
    },
    "payrollSettings": {
      "label": "إعدادات الرواتب",
      "status": "حماية الأجور والعمل الإضافي والإجازات المرضية والمكافأة"
    }
  },
  "documentTypes": {
    "invoice": "الفاتورة",
    "quotation": "عرض السعر",
    "credit_note": "الإشعار الدائن",
    "receipt": "سند القبض",
    "purchase": "أمر الشراء"
  },
  "frame": {
    "lastChanged": "آخر تغيير {{date}}",
    "lastChangedBy": "آخر تغيير {{date}} بواسطة {{name}}",
    "lastChangedByYou": "آخر تغيير {{date}} بواسطتك",
    "history": "السجل",
    "needs": "للقراءة فقط: يتطلب تغييره صلاحية «{{permission}}».",
    "fixed": {
      "provider": "للقراءة فقط: يغيّره مزوّد الخدمة.",
      "numbering": "للقراءة فقط: الصيغ ثابتة في هذا الإصدار، وتستمر كل سلسلة من آخر رقم فيها.",
      "regional": "للقراءة فقط: ثابتة للشركات في عُمان.",
      "system": "للقراءة فقط: تُحدَّد عند تثبيت التطبيق."
    }
  },
  "saveBar": {
    "unsaved": "تغييرات غير محفوظة",
    "clean": "لا توجد تغييرات غير محفوظة",
    "discard": "تجاهل",
    "shortcut": "{{keys}} للحفظ"
  },
  "conflict": {
    "title": "حفظ شخص آخر هذا القسم أثناء تعديلك",
    "body": "لم تُحفظ تغييراتك بعد. حمّل تغييراته، ثم أعد تطبيق تغييراتك.",
    "reload": "تحميل تغييراته",
    "reloadedTitle": "حُمّلت تغييراته",
    "youChanged": "كنت قد غيّرت: {{fields}}.",
    "separator": "، ",
    "reapply": "إعادة تطبيق تغييراتي",
    "dismiss": "إغلاق"
  },
  "units": {
    "days": "يوم"
  },
  "proof": {
    "title": "معاينة الطباعة",
    "unsaved": "تغييرات غير محفوظة",
    "saved": "كما حُفظت",
    "show": "معاينة",
    "hide": "إخفاء المعاينة",
    "jump": "معاينة",
    "language": "لغة الطباعة",
    "a4": "عرض كما يُطبع (A4)",
    "documentType": "المستند",
    "note": "مستند نموذجي يُطبع بهذه الإعدادات قبل حفظها.",
    "receiptNote": "يُطبع سند القبض بشروط سندات القبض، دون التذييل وتفاصيل الدفع. ولا يحمل سند الصرف للاسترداد أي شروط."
  },
  "company": {
    "blocks": {
      "name": "الاسم في التطبيق",
      "nameBody": "يظهر في التطبيق، وفي المستندات ما لم يُسجَّل اسم قانوني بعد.",
      "legal": "الهوية القانونية",
      "legalBody": "تُطبع في رأس الفواتير وعروض الأسعار والإشعارات الدائنة والكشوف والتقارير.",
      "contact": "العنوان والتواصل"
    },
    "displayName": "اسم الشركة",
    "displayNameAr": "اسم الشركة بالعربية",
    "displayNameHint": "مطلوب. يُطبع الاسم القانوني أدناه في المستندات عند تعبئته.",
    "legalName": "الاسم القانوني",
    "legalNameAr": "الاسم القانوني بالعربية",
    "vatNumber": "رقم التسجيل الضريبي",
    "vatNumberHint": "في عُمان: OM متبوعًا بـ 10 أرقام.",
    "vatNumberOdd": "هذا الرقم ليس بالصيغة المعتادة (OM متبوعًا بـ 10 أرقام). تحقّق منه؛ ويمكنك حفظه رغم ذلك.",
    "crNumber": "رقم السجل التجاري",
    "address": "العنوان",
    "addressAr": "العنوان بالعربية",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "images": {
      "logo": "شعار الشركة",
      "signature": "التوقيع المعتمد",
      "stamp": "ختم الشركة"
    },
    "save": "حفظ ملف الشركة",
    "toast": {
      "saved": "حُفظ ملف الشركة"
    }
  },
  "printing": {
    "footer": {
      "title": "التذييل",
      "body": "يُطبع في أسفل كل مستند، بالإنجليزية والعربية.",
      "en": "التذييل (بالإنجليزية)",
      "ar": "التذييل (بالعربية)"
    },
    "terms": {
      "title": "الشروط والأحكام",
      "body": "نص افتراضي لكل المستندات، ونص خاص لكل نوع يحتاج إليه.",
      "default": "الشروط الافتراضية (لكل المستندات)",
      "en": "الشروط (بالإنجليزية)",
      "ar": "الشروط (بالعربية)",
      "byDocument": "الشروط حسب المستند",
      "customised": "مخصّصة",
      "usesDefault": "{{document}}: تستخدم الشروط الافتراضية.",
      "customise": "تخصيص شروط {{document}}",
      "noDefault": "الشروط الافتراضية فارغة، فلا يُطبع شيء.",
      "reset": "العودة إلى الشروط الافتراضية",
      "of": "شروط {{document}}",
      "ofEn": "شروط {{document}} (بالإنجليزية)",
      "ofAr": "شروط {{document}} (بالعربية)",
      "blankUsesDefault": "اترك إحدى اللغتين فارغة لتُطبع فيها الشروط الافتراضية.",
      "defaultPlaceholder": "تستخدم الشروط الافتراضية"
    },
    "payment": {
      "title": "بيانات الدفع",
      "body": "كيف يدفع لك العملاء: الحسابات البنكية المطبوعة على المستندات، وسطر تكتبه بنفسك.",
      "accounts": "الحسابات البنكية المطبوعة",
      "accountsHint": "حتى {{max}} حسابات. يُؤخذ اسم البنك ورقم الحساب والآيبان من كل حساب في النقدية والبنوك، فتبقى صحيحة.",
      "noBanks": "لا توجد حسابات بنكية بعد. أضف حسابًا من النقدية والبنوك.",
      "noBanksNew": "لا توجد حسابات بنكية بعد. أضف حسابًا هنا، فيُحدَّد للطباعة.",
      "accountNo": "رقم الحساب",
      "iban": "الآيبان",
      "noNumbers": "لم يُسجَّل رقم حساب ولا آيبان",
      "archived": "مؤرشف: لا يُطبع على المستندات. ألغِ تحديده.",
      "inactive": "أحد الحسابات التي اخترتها لم يعد حسابًا بنكيًا نشطًا. ألغِ تحديده واحفظ من جديد.",
      "unknownAccount": "حساب لم يعد مستخدمًا",
      "text": "نص الدفع",
      "textEn": "نص الدفع (بالإنجليزية)",
      "textAr": "نص الدفع (بالعربية)",
      "textHint": "يُطبع أسفل الحسابات، مثل: «يرجى ذكر رقم الفاتورة»."
    },
    "sharing": {
      "title": "المشاركة",
      "qr": "رمز QR على الفواتير المطبوعة",
      "qrHint": "لا تحمل الفواتير المطبوعة رمز QR بعد؛ يُحتفظ بهذا الاختيار إلى حين ذلك.",
      "qrNone": "بدون رمز QR",
      "qrLink": "رابط الفاتورة على الإنترنت",
      "qrLinkBody": "تُنشئ طباعة الفاتورة المرحّلة رابط مشاركتها لهذا الرمز.",
      "linkDays": "تنتهي روابط المشاركة بعد",
      "linkDaysHint": "0 تعني أنها لا تنتهي. يمكن لمن يشارك الرابط اختيار مدة أخرى.",
      "linkDaysInvalid": "أدخل عددًا صحيحًا من الأيام بين 0 و3650."
    },
    "hijri": {
      "title": "التاريخ الهجري",
      "body": "يمكن أن تحمل المستندات المطبوعة التاريخ الهجري (أم القرى) بجانب التاريخ الميلادي.",
      "label": "إظهار التاريخ الهجري",
      "never": "أبدًا",
      "legal": "في المستندات الرسمية",
      "legalBody": "العقود وخطابات العرض والخطابات الرسمية.",
      "always": "دائمًا",
      "sampleInvoice": "فاتورة",
      "sampleLegal": "مستند رسمي"
    },
    "save": "حفظ إعدادات الطباعة",
    "toast": {
      "saved": "حُفظت إعدادات الطباعة"
    }
  },
  "numbering": {
    "document": "المستند",
    "format": "الصيغة",
    "next": "الرقم التالي",
    "yearly": "يُعاد الترقيم",
    "everyYear": "كل سنة ({{year}})",
    "continues": "أبدًا",
    "unused": "لم يُستخدم بعد"
  },
  "defaults": {
    "blocks": {
      "prices": "الأسعار",
      "dates": "التواريخ"
    },
    "pricesIncludeTax": "الأسعار شاملة ضريبة القيمة المضافة",
    "pricesIncludeTaxHint": "للفواتير وعروض الأسعار والإشعارات الدائنة وفواتير الشراء الجديدة. عند التفعيل: السعر المُدخل هو المبلغ المدفوع شاملًا الضريبة. عند الإيقاف: تُضاف الضريبة إليه.",
    "paymentTerms": "مدة السداد",
    "paymentTermsHint": "تستحق الفواتير وفواتير الشراء بعد هذا العدد من الأيام من تاريخها، ما لم يُختر تاريخ استحقاق آخر.",
    "paymentTermsInvalid": "أدخل عددًا صحيحًا من الأيام بين 0 و365.",
    "quotationValidity": "مدة صلاحية عروض الأسعار",
    "quotationValidityHint": "يبدأ تاريخ صلاحية عرض السعر الجديد بعد هذا العدد من الأيام من تاريخه.",
    "quotationValidityInvalid": "أدخل عددًا صحيحًا من الأيام بين 1 و365.",
    "discountType": "نوع الخصم الافتراضي",
    "discountTypeHint": "النوع الذي يبدأ به البند الجديد. ويبقى بوسع كل بند استخدام أي من الأنواع الثلاثة.",
    "discountTypes": {
      "PERCENTAGE": "نسبة من البند، مثل 10%.",
      "PER_UNIT": "مبلغ يُخصم من كل وحدة، مثل 0.500 للوحدة.",
      "LINE_AMOUNT": "مبلغ يُخصم من إجمالي البند، مثل 5.000 من البند."
    },
    "sentence": {
      "due": "الفاتورة المؤرخة اليوم تستحق في {{date}}",
      "valid": "وعرض السعر صالح حتى {{date}}",
      "discount": "وتبدأ البنود الجديدة بخصم {{type}}",
      "separator": "، ",
      "end": "."
    },
    "impact": {
      "title": "تغيير طريقة إدخال الأسعار؟",
      "including": "ستُدخل أسعار المستندات الجديدة شاملة ضريبة القيمة المضافة. تحتفظ المسودات الحالية بطريقتها.",
      "excluding": "ستُدخل أسعار المستندات الجديدة غير شاملة ضريبة القيمة المضافة. تحتفظ المسودات الحالية بطريقتها.",
      "confirmIncluding": "إدخال الأسعار شاملة الضريبة",
      "confirmExcluding": "إدخال الأسعار دون الضريبة"
    },
    "save": "حفظ القيم الافتراضية",
    "toast": {
      "saved": "حُفظت القيم الافتراضية"
    }
  },
  "priceLevels": {
    "title": "مستويات الأسعار",
    "intro": "يشتري كل عميل بأسعار التجزئة أو الجملة أو جملة الجملة. السعر المحدد على المنتج يُقدَّم دائمًا؛ وإن لم يكن للمنتج سعر لمستوى العميل، يُباع بسعر التجزئة مخصومًا منه النسبة أدناه.",
    "wholesale": "الجملة: نسبة الخصم من سعر التجزئة",
    "wholesaleHint": "عندما لا يكون للمنتج سعر جملة.",
    "distributor": "جملة الجملة: نسبة الخصم من سعر التجزئة",
    "distributorHint": "عندما لا يكون للمنتج سعر جملة الجملة.",
    "example": "التجزئة {{retail}} بخصم {{pct}}% ← {{price}}",
    "exampleZero": "عند 0% يُباع بسعر التجزئة.",
    "invalid": "أدخل نسبة من 0 إلى 100، بمنزلتين عشريتين على الأكثر.",
    "save": "حفظ مستويات الأسعار",
    "toast": {
      "saved": "حُفظت مستويات الأسعار"
    }
  },
  "payments": {
    "defaultAccounts": "الحساب الافتراضي لكل نوع",
    "defaultAccountsBody": "تبدأ سندات القبض والاستردادات ومدفوعات الموردين بهذا الحساب للنوع المختار، إلا إذا كان لطريقة الدفع المختارة حساب خاص بها، ومن استخدم حسابًا آخر لهذا النوع في المرة السابقة يبدأ بحسابه. لا يعرض كل نوع إلا الحسابات التي تناسبه: النقد لحساب نقدية فقط، وحساب النقدية لا يقبل البطاقة ولا التحويل البنكي.",
    "none": "غير محدد",
    "manageAccounts": "النقدية والبنوك",
    "accountsModuleOff": "النقد والبنوك جزء من المحاسبة، وهي متوقفة لشركتك. ما زال بإمكانك إضافة الحسابات أدناه وتعديلها وأرشفتها؛ وتعود الأرصدة والأرصدة الافتتاحية والتحويلات عند تشغيل المحاسبة.",
    "tillNote": "تقبل الصناديق النقد والبطاقة وطرق الدفع المتاحة في نقطة البيع، عبر الدرج وحساب البطاقة المحددين لكل صندوق (أو الحساب الخاص بالطريقة).",
    "save": "حفظ الحسابات الافتراضية",
    "toast": {
      "saved": "حُفظت الحسابات الافتراضية"
    },
    "accounts": "حسابات النقد والبنوك",
    "accountsBody": "صناديق النقد والحسابات البنكية وأجهزة البطاقات والمحافظ التي تُودَع فيها المدفوعات، مع البيانات البنكية المطبوعة على المستندات. الأرصدة والأرصدة الافتتاحية والتحويلات جزء من المحاسبة.",
    "methods": {
      "title": "طرق الدفع الخاصة بالشركة",
      "body": "طرق الدفع التي تستلم بها شركتك وتدفع بها، بأسمائها: فيزا، ماستركارد، ثواني، تحويل إلى بنك مسقط. لكل طريقة نوع يحدد معالجتها المحاسبية، ويمكن أن تبدأ بحساب خاص بها وأن تكون متاحة في نقطة البيع. تُحفظ التغييرات هنا فورًا.",
      "add": "إضافة طريقة دفع",
      "showArchived": "عرض المؤرشفة ({{count}})",
      "empty": "لا توجد طرق دفع خاصة بالشركة بعد",
      "emptyBody": "أضف البطاقات والمحافظ والتحويلات التي تستخدمها، مثل فيزا أو ثواني أو التحويل إلى بنك مسقط. تظهر في سندات القبض والاستردادات ومدفوعات الموردين وتحصيلات الخدمة، وفي نقطة البيع إذا جعلتها متاحة فيها.",
      "typeDefault": "الحساب الافتراضي للنوع",
      "atTill": "في نقطة البيع",
      "archived": "مؤرشفة",
      "used_zero": "لم تُستخدم بعد",
      "used_one": "مستخدمة في مستند واحد",
      "used_two": "مستخدمة في مستندين",
      "used_few": "مستخدمة في {{count}} مستندات",
      "used_many": "مستخدمة في {{count}} مستندًا",
      "used_other": "مستخدمة في {{count}} مستند",
      "notUsed": "لم تُستخدم بعد",
      "edit": "تعديل {{name}}",
      "archive": "أرشفة {{name}}",
      "restore": "استعادة",
      "restoreNamed": "استعادة {{name}}",
      "archiveTitle": "أرشفة {{name}}؟",
      "archiveBody": "ستختفي من نماذج الدفع ومن نقطة البيع. تحتفظ المستندات المسجلة بها باسمها، ويمكنك استعادتها في أي وقت.",
      "archiveConfirm": "أرشفة",
      "restoreAccount": "لا يمكن استعادة {{name}} على حسابها: ذلك الحساب مؤرشف أو لم يعد يقبلها. عدّل الطريقة لتختار حسابًا آخر، ثم استعِدها.",
      "toast": {
        "created": "أُضيفت {{name}}",
        "updated": "حُفظت {{name}}",
        "archived": "أُرشفت {{name}}",
        "restored": "استُعيدت {{name}}"
      }
    },
    "methodDialog": {
      "newTitle": "إضافة طريقة دفع",
      "editTitle": "تعديل طريقة الدفع",
      "newSubtitle": "طريقة تستلم بها شركتك أو تدفع بها، مثل فيزا أو ثواني.",
      "name": "الاسم",
      "namePlaceholder": "مثال: Visa",
      "nameAr": "الاسم بالعربية",
      "nameArPlaceholder": "مثال: فيزا",
      "type": "النوع",
      "typeLocked": "سُجلت مستندات بهذه الطريقة، لذا يبقى نوعها كما هو.",
      "typeHelp": {
        "CASH": "أوراق نقدية وعملات تُحفظ في صندوق النقدية.",
        "CARD": "بطاقات الخصم والائتمان عبر جهاز الدفع.",
        "BANK_TRANSFER": "مبالغ تُحوَّل مباشرة إلى حساب بنكي.",
        "CHEQUE": "شيك يُودَع في البنك لاحقًا.",
        "OTHER": "المحافظ وتطبيقات الدفع، مثل ثواني."
      },
      "account": "الحساب",
      "accountHint": "حساب النقدية أو البنك الذي تبدأ به في نماذج الدفع. إن لم تحدده يُستخدم الحساب الافتراضي للنوع أدناه.",
      "atTill": "متاحة في نقطة البيع",
      "atTillHint": "تظهر بجانب البطاقة عند استلام الدفع في نقطة البيع.",
      "atTillCash": "لا تنطبق على النقد: النقد في نقطة البيع يذهب إلى الدرج.",
      "atTillAccounts": "ما دامت متاحة في نقطة البيع فإنها تذهب إلى حساب جهاز بطاقات أو بنك أو محفظة، لذا لا تظهر حسابات النقدية.",
      "tillAccount": "لا يمكن أن تذهب طريقة متاحة في نقطة البيع إلى حساب نقدية. اختر حساب جهاز بطاقات أو بنك أو محفظة، أو الحساب الافتراضي للنوع.",
      "save": "حفظ الطريقة",
      "nameTaken": "توجد طريقة دفع بهذا الاسم.",
      "nameTakenArchived": "توجد طريقة دفع مؤرشفة بهذا الاسم.",
      "nameTakenArchivedHint": "تحتفظ الطرق المؤرشفة بأسمائها. أعد تسمية تلك الطريقة أو استعِدها، أو اختر اسمًا آخر.",
      "showArchived": "عرض الطرق المؤرشفة",
      "version": "عدّل شخص آخر هذه الطريقة منذ فتحتها. أغلقها وافتحها من جديد لترى تعديلاته."
    }
  },
  "stock": {
    "policy": "حين تُنزل عملية بيعٍ المخزونَ إلى ما دون الصفر",
    "policyBody": "تنطبق عند ترحيل الفاتورة وعند إتمام البيع في شاشة البيع.",
    "options": {
      "ALLOW": {
        "label": "السماح",
        "body": "يتم الترحيل والبيع دون أي تنبيه عن المخزون."
      },
      "WARN": {
        "label": "التنبيه",
        "body": "يعرض ترحيل الفاتورة الأصناف الناقصة ويبقى ممكنًا؛ وتبيع شاشة البيع كالمعتاد."
      },
      "BLOCK": {
        "label": "المنع",
        "body": "تُرفض الفواتير وعمليات البيع التي تُنزل المخزون إلى ما دون الصفر."
      }
    },
    "defaultWarehouse": "المستودع الافتراضي",
    "defaultWarehouseBody": "تسحب المبيعات التي لا مستودع لها من المستودع الرئيسي.",
    "manageWarehouses": "المستودعات",
    "impact": {
      "blockTitle": "منع المبيعات التي تُنزل المخزون إلى ما دون الصفر؟",
      "block": "ستُرفض من الآن الفواتير وعمليات البيع التي تُنزل المخزون إلى ما دون الصفر. لا تتغير المستندات المرحّلة.",
      "blockDrafts": "لا يمكن ترحيل المسودات التي تُنزل المخزون إلى ما دون الصفر.",
      "blockConfirm": "منع المخزون السالب",
      "allowTitle": "إيقاف التنبيه عن المخزون؟",
      "allow": "لن يظهر أي تنبيه حين تُنزل عملية بيعٍ المخزونَ إلى ما دون الصفر.",
      "allowConfirm": "السماح بالمخزون السالب"
    },
    "save": "حفظ سياسة المخزون",
    "toast": {
      "saved": "حُفظت سياسة المخزون"
    }
  },
  "lock": {
    "date": "إقفال الترحيل في تاريخ أو قبله",
    "dateBody": "لا يمكن لأي أحد ترحيل أو إبطال أو عكس أي شيء مؤرخ في هذا التاريخ أو قبله. ولا يجوز أن يتجاوز تاريخ اليوم.",
    "none": "لا يوجد تاريخ إقفال",
    "clear": "إزالة تاريخ الإقفال",
    "warning": "لا يمكن ترحيل أو تعديل أي شيء مؤرخ في {{date}} أو قبله.",
    "noLock": "لا يوجد تاريخ إقفال: يمكن الترحيل في أي تاريخ من سنة مالية مفتوحة.",
    "closedYears": "السنوات المالية المُقفلة",
    "closedYearsBody": "تبقى السنة المُقفلة مُقفلة؛ ولا يجوز أن يسبق تاريخُ الإقفال نهايتَها.",
    "yearRange": "{{from}} – {{to}}",
    "noClosedYears": "لا توجد سنة مالية مُقفلة.",
    "closedThrough": "مُقفلة حتى {{date}}.",
    "errors": {
      "future": "لا يجوز أن يتجاوز تاريخ الإقفال تاريخ اليوم.",
      "closedYear": "الدفاتر مُقفلة حتى {{date}}: لا يجوز تقديم تاريخ الإقفال عنه أو إزالته ما دامت تلك السنة مُقفلة.",
      "closedYearNoDate": "تبقى السنة المالية المُقفلة مُقفلة: لا يجوز أن يسبق تاريخُ الإقفال نهايتَها."
    },
    "impact": {
      "laterTitle": "إقفال الدفاتر حتى {{date}}؟",
      "later": "لن يمكن بعد الآن ترحيل أو إبطال أو عكس أي شيء مؤرخ في {{date}} أو قبله. لا تتغير المستندات المرحّلة.",
      "laterDrafts": "لا يمكن ترحيل المسودات المؤرخة في {{date}} أو قبله حتى تنقل تاريخ الإقفال.",
      "earlierTitle": "فتح الفترات من جديد؟",
      "earlier": "تُفتح الفترات من {{from}} إلى {{to}} للترحيل من جديد.",
      "clearTitle": "إزالة تاريخ الإقفال؟",
      "clear": "يُفتح للترحيل من جديد كل ما هو مؤرخ حتى {{date}}، عدا السنوات المالية المُقفلة.",
      "confirm": "نقل تاريخ الإقفال",
      "clearConfirm": "إزالة تاريخ الإقفال"
    },
    "save": "حفظ تاريخ الإقفال",
    "toast": {
      "saved": "أُقفلت الدفاتر حتى {{date}}",
      "cleared": "أُزيل تاريخ الإقفال"
    }
  },
  "tasks": {
    "blocks": {
      "workflow": "المراجعة وتواريخ الاستحقاق",
      "overdue": "الأعمال المتأخرة"
    },
    "review": {
      "label": "المهام الجديدة تحتاج إلى مراجعة افتراضيًا",
      "hint": "تبدأ كل مهمة جديدة وخيار «تحتاج إلى مراجعة» مفعّل، ويستطيع منشئها إيقافه."
    },
    "dueDate": {
      "label": "يستطيع المسؤولون عن المهام تغيير تاريخ الاستحقاق الملتزم به بأنفسهم",
      "hint": "مع ذكر السبب. وإلا فإنهم يطلبون تاريخًا جديدًا من صاحب الطلب أو من قائد الفريق."
    },
    "escalation": {
      "label": "إبلاغ قادة الفريق عند تأخر المهمة مدة",
      "hint": "أدخل 0 كي لا يُبلَّغوا أبدًا. وفي الحالتين يُذكَّر المسؤول عن المهمة كل يوم تتأخر فيه.",
      "invalid": "أدخل عددًا صحيحًا من الأيام من 0 إلى 30."
    },
    "save": "حفظ إعدادات المهام",
    "toast": {
      "saved": "حُفظت إعدادات المهام"
    }
  },
  "projectContracting": {
    "measure": {
      "label": "قياس الأعمال"
    },
    "payment": {
      "label": "سداد المستخلصات"
    },
    "retention": {
      "label": "المحتجزات"
    },
    "advance": {
      "label": "الدفعة المقدمة"
    },
    "damages": {
      "label": "غرامات التأخير"
    },
    "approval": {
      "label": "الموافقة الداخلية على الأوامر التغييرية والمستخلصات"
    },
    "guarantees": {
      "label": "تذكير الضمانات وضمان حسن التنفيذ"
    }
  },
  "projectInsights": {
    "burnGapPts": {
      "label": "الصرف قبل الإنجاز"
    },
    "eacMethod": {
      "label": "التكلفة النهائية المتوقعة"
    },
    "slipToleranceDays": {
      "label": "تأخر موعد الانتهاء"
    },
    "arOverdueDays": {
      "label": "تأخر العميل في السداد"
    },
    "staleDays": {
      "label": "لا نشاط"
    }
  },
  "projects": {
    "features": {
      "title": "الوظائف",
      "body": "أوقف ما لا تستخدمه الشركة، فتختفي تبويباته وحقوله وإجراءاته من كل المشاريع."
    },
    "defaultType": {
      "label": "النوع الذي يبدأ منه المشروع الجديد",
      "hint": "يُختار مسبقًا في نموذج المشروع الجديد، ويمكن لأي شخص اختيار نوع آخر أو البدء بمشروع فارغ.",
      "none": "بلا نوع"
    },
    "progressMethod": {
      "label": "قياس إنجاز المشروع الذي ليس له نوع",
      "hint": "يحدد كل نوع مشروع طريقته الخاصة."
    },
    "save": "حفظ إعدادات المشاريع",
    "toast": {
      "saved": "حُفظت إعدادات المشاريع"
    },
    "budgetThresholds": {
      "label": "مستويات الموازنة"
    },
    "categoryDefaults": {
      "label": "فئة التكلفة عند عدم اختيار فئة"
    },
    "time": {
      "label": "قواعد الوقت"
    }
  },
  "service": {
    "priceApproval": {
      "label": "موافقة العميل على السعر",
      "body": "هل يُسجَّل العمل على البند القابل للفوترة فقط بعد موافقة العميل على سعره.",
      "options": {
        "REQUIRED": {
          "label": "مطلوبة قبل العمل",
          "body": "لا يسجّل الفنيون العمل على بند إلا بعد موافقة العميل على سعره."
        },
        "OPTIONAL": {
          "label": "اختيارية",
          "body": "يمكن تسجيل العمل قبل الاتفاق على السعر، وتأتي الموافقة لاحقًا."
        }
      }
    },
    "reportPhotos": {
      "label": "صور الزيارة",
      "body": "صور تُرفق بالزيارة دليلًا على العمل.",
      "options": {
        "OPTIONAL": {
          "label": "اختيارية",
          "body": "تنتهي الزيارة بصور أو بدونها."
        },
        "REQUIRED": {
          "label": "مطلوبة للإنهاء",
          "body": "لا تنتهي الزيارة إلا بإرفاق صورة واحدة على الأقل."
        }
      }
    },
    "acknowledgment": {
      "label": "إقرار العميل",
      "body": "اسم العميل الذي أكّد تقرير الزيارة.",
      "options": {
        "OPTIONAL": {
          "label": "اختياري",
          "body": "تنتهي الزيارة باسم العميل أو بدونه."
        },
        "REQUIRED": {
          "label": "مطلوب للإنهاء",
          "body": "لا تنتهي الزيارة إلا باسم العميل الذي أقرّ بها."
        }
      }
    },
    "assetRegister": {
      "label": "المواقع والمعدات",
      "body": "تضم مواقع العملاء شجرة من الأماكن (الطوابق والشقق) والمعدات في كل منها، وتحدد أوامر الخدمة الوحدات المعنية.",
      "switch": "تفعيل سجل المواقع والأماكن والمعدات",
      "on": "تظهر «المواقع والمعدات» ضمن الخدمة، ويمكن لأمر الخدمة اختيار مكان ومعداته.",
      "off": "تُخفى الشاشات وحقول أوامر الخدمة. لا يُحذف شيء مما سُجّل، ويظهر من جديد عند إعادة التشغيل."
    },
    "assetChecklists": {
      "label": "قوائم فحص المعدات",
      "body": "يفحص الفنيون كل معدّة في أمر الخدمة أثناء الزيارة: قائمة فحصها وقراءاتها ونتيجتها. لا ينتهي أمر الصيانة المخطط إلا بعد فحص كل المعدات.",
      "switch": "فحص كل معدّة أثناء الزيارة",
      "on": "تعرض الزيارة قائمة فحص كل معدّة، ولا ينتهي الأمر المخطط كاملًا إلا بعد فحص كل معداته.",
      "off": "لا تظهر قائمة الفحص في الزيارة، وتنتهي الأوامر المخططة كأي أمر خدمة. تبقى الفحوص المسجلة محفوظة."
    },
    "save": "حفظ إعدادات الخدمة",
    "toast": {
      "saved": "حُفظت إعدادات الخدمة"
    },
    "visitLead": {
      "label": "قائد الزيارة",
      "body": "هل تُحجز الزيارة بقائد مسمّى، أم للفريق وحده.",
      "options": {
        "REQUIRED": {
          "label": "يُسمّى عند الحجز",
          "body": "كل زيارة تسمّي قائدها؛ الجدول والعميل يعرفان من سيأتي."
        },
        "OPTIONAL": {
          "label": "اختياري",
          "body": "يمكن حجز الزيارة للفريق فقط؛ والعضو الذي يبدؤها يصبح قائدها."
        }
      }
    },
    "followUpApproval": {
      "label": "زيارة أخرى بعد الأولى",
      "body": "عندما يتبقى عمل بعد زيارة، هل تنتظر الزيارة التالية مدير الخدمة.",
      "options": {
        "REQUIRED": {
          "label": "يوافق المدير",
          "body": "يطلب الفريق زيارة متابعة؛ ويوافق عليها مدير الخدمة ويحجز الزيارة."
        },
        "NOT_NEEDED": {
          "label": "تُحجز فورًا",
          "body": "الطلب نفسه يحجز زيارة المتابعة: الفريق والقائد نفسهما، في التاريخ المقترح أو يوم العمل التالي."
        }
      }
    },
    "priceApprovalThreshold": {
      "label": "لا موافقة تحت",
      "body": "مع اشتراط الموافقة، لا يحتاج أمر الخدمة الذي لا يتجاوز إجماليه المحتسب (شامل الضريبة) هذا المبلغ إلى موافقة: رسم زيارة، تغيير فلتر.",
      "field": "المبلغ (ر.ع.)",
      "hint": "اتركه فارغًا لطلب الموافقة في كل أمر خدمة محتسب.",
      "error": "أدخل مبلغًا 0 أو أكثر، أو اتركه فارغًا."
    },
    "simple": {
      "title": "الإعداد البسيط",
      "body": "لفريق صغير: زيارات تُحجز للفريق، متابعات تُحجز فورًا، ولا حاجة لصورة أو توقيع للإنهاء. ويبقى كل بند قابلًا للضبط على حدة أدناه.",
      "apply": "استخدم الإعداد البسيط",
      "applied": "مُلئ الإعداد البسيط: احفظ لتثبيته."
    }
  },
  "contracts": {
    "notice": {
      "label": "تذكيرات التجديد",
      "body": "يُبلَّغ مديرو العقود قبل انتهاء العقد، مرة واحدة عند كل عدد من هذه الأيام.",
      "day": "التذكير {{n}}، عدد الأيام قبل النهاية",
      "days": "يوم قبل النهاية",
      "remove": "إزالة التذكير {{n}}",
      "add": "إضافة تذكير",
      "summary": "تذكير قبل نهاية العقد بـ {{days}} يوم.",
      "none": "لا تذكيرات: لن يُبلَّغ أحد قبل انتهاء العقد.",
      "invalid": "أدخل عدد أيام صحيحًا من 1 إلى 365.",
      "duplicate": "أدخل كل عدد من الأيام مرة واحدة."
    },
    "planAhead": {
      "title": "الزيارات الوقائية",
      "body": "تُنشئ خطط الصيانة في العقد أمر خدمة مخططًا لكل زيارة وقائية يحين موعدها، مبكرًا بما يكفي ليجدولها المكتب.",
      "label": "إنشاء الأوامر المخططة",
      "unit": "يوم قبل موعد استحقاقها",
      "invalid": "أدخل عدد أيام صحيحًا من 1 إلى 90."
    },
    "billing": {
      "title": "فوترة العقد الجديد",
      "body": "كيف تُقسَّم قيمة العقد الجديد إلى أقساط. يمكن تغيير ذلك في كل عقد."
    },
    "schedule": {
      "label": "جدول الفوترة",
      "options": {
        "MONTHLY": "شهري",
        "QUARTERLY": "ربع سنوي",
        "HALF_YEARLY": "نصف سنوي",
        "YEARLY": "سنوي",
        "UPFRONT": "مقدمًا (قسط واحد)",
        "CUSTOM": "مخصص (تُدخَل الأقساط يدويًا)"
      }
    },
    "timing": {
      "label": "موعد فوترة كل قسط",
      "options": {
        "ADVANCE": {
          "label": "مقدمًا",
          "body": "يُفوتَر في أول يوم من كل فترة."
        },
        "ARREARS": {
          "label": "مؤخرًا",
          "body": "يُفوتَر في آخر يوم من كل فترة."
        }
      }
    },
    "terms": {
      "title": "شروط العقد الجديد",
      "body": "ما يغطيه العقد الجديد ما لم يُنص على غير ذلك. يمكن تغيير الشروط في كل عقد.",
      "labour": {
        "label": "العمالة",
        "options": {
          "INCLUDED": {
            "label": "مشمولة",
            "body": "لا يُحتسب العمل على المعدات المشمولة."
          },
          "EXCLUDED": {
            "label": "بمقابل",
            "body": "يُحتسب العمل بمقابل في كل أمر خدمة."
          }
        }
      },
      "parts": {
        "label": "قطع الغيار",
        "options": {
          "INCLUDED": {
            "label": "مشمولة",
            "body": "لا تُحتسب القطع المركّبة في المعدات المشمولة."
          },
          "EXCLUDED": {
            "label": "بمقابل",
            "body": "تُحتسب القطع بمقابل."
          },
          "CAPPED": {
            "label": "مشمولة حتى سقف",
            "body": "مشمولة حتى مبلغ محدد، وما زاد عليه بمقابل."
          }
        }
      },
      "partsCap": {
        "label": "سقف قطع الغيار",
        "missing": "أدخل سقف قطع الغيار، أكبر من صفر."
      },
      "partsCapBasis": {
        "label": "يُحتسب السقف",
        "options": {
          "PER_JOB": "لكل أمر خدمة",
          "PER_YEAR": "لكل سنة عقد"
        },
        "missing": "لكل أمر خدمة أم لكل سنة عقد؟"
      },
      "consumables": {
        "label": "المواد المستهلكة",
        "options": {
          "INCLUDED": {
            "label": "مشمولة",
            "body": "لا تُحتسب الفلاتر والغاز وغيرها من المستهلكات."
          },
          "EXCLUDED": {
            "label": "بمقابل",
            "body": "تُحتسب المستهلكات بمقابل."
          }
        }
      },
      "callOuts": {
        "label": "بلاغات الأعطال",
        "options": {
          "INCLUDED": {
            "label": "مشمولة",
            "body": "لا تُحتسب زيارات الأعطال التي يطلبها العميل، ضمن العدد المسموح."
          },
          "EXCLUDED": {
            "label": "بمقابل",
            "body": "يُحتسب كل بلاغ عطل بمقابل."
          }
        }
      },
      "callOutsPerYear": {
        "label": "بلاغات الأعطال في السنة",
        "hint": "اتركه فارغًا لعدد غير محدود.",
        "invalid": "أدخل عددًا صحيحًا من 1 إلى 365، أو اتركه فارغًا."
      },
      "responseHours": {
        "label": "زمن الاستجابة",
        "unit": "ساعة",
        "hint": "اختياري: زمن الاستجابة الموعود للعميل، ويظهر على أوامر خدمة العقد.",
        "invalid": "أدخل عدد ساعات صحيحًا من 1 إلى 720، أو اتركه فارغًا."
      },
      "specialTerms": {
        "label": "شروط خاصة",
        "hint": "ما لا تذكره الشروط العامة، ويُطبع على العقد."
      }
    },
    "consumables": {
      "label": "فئات المواد المستهلكة",
      "body": "منتجات الكتالوج في هذه الفئات تُعد مواد مستهلكة في أوامر خدمة العقد (الفلاتر والغاز ومواد التنظيف)، وبقية البضائع تُعد قطع غيار.",
      "placeholder": "اختر الفئات",
      "search": "ابحث في الفئات",
      "empty": "لا توجد فئات",
      "clear": "مسح الفئات",
      "chosen": "الفئات المختارة: {{n}}",
      "needs": "اختيار الفئات يتطلب صلاحية «{{permission}}».",
      "tooMany": "50 فئة على الأكثر."
    },
    "save": "حفظ إعدادات العقود",
    "toast": {
      "saved": "حُفظت إعدادات العقود"
    }
  },
  "calendar": {
    "week": {
      "title": "أسبوع العمل",
      "hint": "أيام العمل وساعات الدوام في كل منها. المؤقتات المحسوبة بساعات العمل (مثل مهل الموافقات) لا تجري إلا داخل هذه الساعات.",
      "count_zero": "لا أيام عمل",
      "count_one": "يوم عمل واحد",
      "count_two": "يوما عمل",
      "count_few": "{{n}} أيام عمل",
      "count_many": "{{n}} يوم عمل",
      "count_other": "{{n}} يوم عمل",
      "start": "بداية دوام {{day}}",
      "end": "نهاية دوام {{day}}",
      "off": "يوم عطلة",
      "save": "حفظ أسبوع العمل",
      "saved": "تم حفظ أسبوع العمل",
      "errors": {
        "none": "يجب أن يكون يوم واحد على الأقل من الأسبوع يوم عمل.",
        "order": "يجب أن تكون بداية يوم العمل قبل نهايته.",
        "orderOn": "يجب أن تكون بداية يوم {{day}} قبل نهايته."
      }
    },
    "conflict": {
      "title": "غيّر شخص آخر أسبوع العمل",
      "body": "أعد التحميل لرؤية نسخته، ثم أعد إجراء تغييرك.",
      "reload": "إعادة التحميل"
    },
    "holidays": {
      "title": "العطل الرسمية",
      "hint": "أيام العطل إضافةً إلى العطلة الأسبوعية. اجعل التاريخ مبدئيًا ما دام مرتبطًا برؤية الهلال.",
      "add": "إضافة عطلة",
      "edit": "تعديل",
      "delete": "حذف",
      "actionsFor": "إجراءات {{name}}",
      "previousYear": "السنة السابقة",
      "nextYear": "السنة التالية",
      "year": "{{year}}",
      "tableLabel": "العطل في {{year}}",
      "count_zero": "لا عطل",
      "count_one": "عطلة واحدة",
      "count_two": "عطلتان",
      "count_few": "{{n}} عطل",
      "count_many": "{{n}} عطلة",
      "count_other": "{{n}} عطلة",
      "provisionalCount_zero": "لا عطل مبدئية",
      "provisionalCount_one": "واحدة مبدئية",
      "provisionalCount_two": "اثنتان مبدئيتان",
      "provisionalCount_few": "{{n}} مبدئية",
      "provisionalCount_many": "{{n}} مبدئية",
      "provisionalCount_other": "{{n}} مبدئية",
      "empty": "لا توجد عطل في {{year}}",
      "emptyHint": "أضفها واحدة تلو الأخرى أو استوردها من ملف CSV."
    },
    "fields": {
      "date": "التاريخ",
      "days": "عدد الأيام",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية"
    },
    "provisional": {
      "label": "مبدئية",
      "badge": "مبدئية",
      "hint": "قد يتغير التاريخ (مثلًا يرتبط العيد برؤية الهلال)."
    },
    "dialog": {
      "addTitle": "إضافة عطلة",
      "editTitle": "تعديل العطلة",
      "add": "إضافة العطلة",
      "save": "حفظ العطلة",
      "until": "حتى {{date}}"
    },
    "delete": {
      "title": "حذف {{name}}؟",
      "body": "يعود {{date}} يومًا عاديًا، وتُعاد حساب مواعيد الاستحقاق.",
      "confirm": "حذف العطلة"
    },
    "toast": {
      "added_zero": "لم تُضف أي عطلة",
      "added_one": "تمت إضافة العطلة",
      "added_two": "تمت إضافة يومي عطلة",
      "added_few": "تمت إضافة {{count}} أيام عطلة",
      "added_many": "تمت إضافة {{count}} يوم عطلة",
      "added_other": "تمت إضافة {{count}} يوم عطلة",
      "updated": "تم حفظ العطلة",
      "deleted": "تم حذف {{name}}"
    },
    "errors": {
      "HOLIDAY_DATE_TAKEN": "توجد عطلة أخرى في هذا التاريخ.",
      "stale": "غيّر شخص آخر هذه العطلة. أغلق النافذة وافتحها مجددًا.",
      "date": "اختر تاريخًا بين 2000 و2100.",
      "days": "أدخل عددًا صحيحًا من الأيام من 1 إلى {{max}}."
    },
    "import": {
      "action": "استيراد CSV",
      "title": "استيراد العطل",
      "hint": "تُضاف كل الصفوف أو لا يُضاف أي منها.",
      "file": "ملف CSV",
      "paste": "أو الصق الصفوف",
      "format": "عطلة واحدة في كل سطر: التاريخ، الاسم، الاسم بالعربية، مبدئية (نعم/لا). التاريخ بصيغة 2026-11-18 أو 18/11/2026.",
      "replace": "استبدال عطل {{year}}",
      "syntax": "تعذرت قراءة الملف: راجع علامات الاقتباس في السطر {{line}}.",
      "tooMany": "يمكن استيراد {{max}} صفًا على الأكثر في المرة الواحدة.",
      "problems_zero": "لا صفوف تحتاج إلى تصحيح.",
      "problems_one": "صف واحد يحتاج إلى تصحيح قبل الاستيراد.",
      "problems_two": "صفان يحتاجان إلى تصحيح قبل الاستيراد.",
      "problems_few": "{{n}} صفوف تحتاج إلى تصحيح قبل الاستيراد.",
      "problems_many": "{{n}} صفًا تحتاج إلى تصحيح قبل الاستيراد.",
      "problems_other": "{{n}} صف تحتاج إلى تصحيح قبل الاستيراد.",
      "allGood_zero": "لا صفوف للاستيراد.",
      "allGood_one": "صف واحد جاهز للاستيراد.",
      "allGood_two": "صفان جاهزان للاستيراد.",
      "allGood_few": "{{n}} صفوف جاهزة للاستيراد.",
      "allGood_many": "{{n}} صفًا جاهزة للاستيراد.",
      "allGood_other": "{{n}} صف جاهزة للاستيراد.",
      "confirm_zero": "استيراد",
      "confirm_one": "استيراد صف واحد",
      "confirm_two": "استيراد صفين",
      "confirm_few": "استيراد {{n}} صفوف",
      "confirm_many": "استيراد {{n}} صفًا",
      "confirm_other": "استيراد {{n}} صف",
      "previewLabel": "الصفوف المراد استيرادها",
      "line": "السطر",
      "check": "الفحص",
      "ok": "جاهز",
      "done_zero": "لم تُستورد أي عطلة",
      "done_one": "تم استيراد عطلة واحدة",
      "done_two": "تم استيراد عطلتين",
      "done_few": "تم استيراد {{n}} عطل",
      "done_many": "تم استيراد {{n}} عطلة",
      "done_other": "تم استيراد {{n}} عطلة",
      "issues": {
        "date": "تعذرت قراءة التاريخ",
        "name": "الاسم مفقود",
        "duplicate": "التاريخ مكرر في الملف",
        "taken": "عطلة موجودة مسبقًا",
        "outsideYear": "خارج السنة"
      }
    }
  },
  "notifications": {
    "email": "مرسل البريد الإلكتروني",
    "emailBody": "تُرسل الرسائل من عنوان المنصة باسم شركتك.",
    "fromName": "اسم المرسل",
    "fromNameHint": "ما يراه العملاء اسمًا للمرسل، مثل «النور للتجارة». إن تُرك فارغًا: اسم شركتك.",
    "replyTo": "عنوان الرد",
    "replyToHint": "إلى أين تصل ردود العملاء. إن تُرك فارغًا: إلى عنوان المرسل.",
    "whatsapp": "واتساب",
    "whatsappEnabled": "إرسال رسائل واتساب",
    "whatsappHint": "يتطلب مفتاح واجهة واتساب أدناه.",
    "key": {
      "label": "مفتاح واجهة واتساب",
      "body": "يُحفظ مشفّرًا ولا يُعرض مرة أخرى بعد حفظه، ولا حتى لك.",
      "set": "مضبوط",
      "setOn": "ضُبط في {{date}}",
      "setOnBy": "ضُبط في {{date}} بواسطة {{name}}",
      "setOnByYou": "ضُبط في {{date}} بواسطتك",
      "notSet": "غير مضبوط",
      "setAction": "ضبط المفتاح",
      "replace": "استبدال المفتاح",
      "remove": "إزالة المفتاح",
      "needs": "يتطلب ضبط المفتاح أو إزالته صلاحية «إدارة الأسرار».",
      "setTitle": "ضبط {{name}}",
      "replaceTitle": "استبدال {{name}}",
      "dialogBody": "الصق المفتاح الذي أعطاك إياه مزوّد واتساب. يُرسل مرة واحدة، ويُحفظ مشفّرًا، ولا يُعرض مرة أخرى.",
      "removeTitle": "إزالة مفتاح واجهة واتساب؟",
      "removeBody": "لن يمكن إرسال رسائل واتساب حتى يُضبط مفتاح من جديد.",
      "toast": {
        "set": "ضُبط مفتاح واجهة واتساب",
        "replaced": "استُبدل مفتاح واجهة واتساب",
        "removed": "أُزيل مفتاح واجهة واتساب"
      }
    },
    "save": "حفظ إعدادات المراسلة",
    "toast": {
      "saved": "حُفظت إعدادات المراسلة"
    },
    "notReady": {
      "title": "البريد الإلكتروني غير مُعد",
      "body": "لن تصل الرسائل إلى العملاء حتى يُضبط الإرسال.",
      "link": "اضبط الإرسال"
    },
    "sender": "المرسل",
    "senderBody": "الاسم وعنوان الرد اللذان يراهما العملاء في كل رسالة.",
    "delivery": {
      "title": "إرسال البريد",
      "body": "أي خدمة بريد ترسل رسائلك.",
      "PLATFORM": {
        "label": "خدمة بريد سحاب",
        "body": "تُرسل من عنوان المنصة باسم شركتك. لا يلزم أي إعداد."
      },
      "SMTP": {
        "label": "خادم بريد شركتك (SMTP)",
        "body": "تُرسل من عنوان شركتك عبر خادم بريدها. يلزم إدخال بياناته أدناه."
      }
    },
    "smtp": {
      "host": "عنوان الخادم",
      "hostHint": "مثل smtp.office365.com",
      "port": "المنفذ",
      "portHint": "عادةً 587 مع STARTTLS، أو 465 مع TLS.",
      "security": "التشفير",
      "securityModes": {
        "STARTTLS": "STARTTLS (عادةً المنفذ 587)",
        "TLS": "TLS (عادةً المنفذ 465)"
      },
      "username": "اسم المستخدم",
      "fromAddress": "عنوان المرسل",
      "fromAddressHint": "العنوان الذي تُرسل منه الرسائل، مثل accounts@yourcompany.om.",
      "required": "مطلوب عند الإرسال عبر خادم شركتك",
      "invalidHost": "أدخل اسم خادم مثل smtp.example.com",
      "invalidPort": "استخدم المنفذ 25 أو 465 أو 587 أو 2525",
      "hostNotAllowed": "هذا الخادم على شبكة خاصة. أدخل الاسم العام لخادم بريدك."
    },
    "password": {
      "label": "كلمة مرور خادم البريد",
      "body": "تُحفظ مشفّرة ولا تظهر مرة أخرى بعد حفظها، ولا حتى لك.",
      "setAction": "تعيين كلمة المرور",
      "replace": "استبدال كلمة المرور",
      "remove": "إزالة كلمة المرور",
      "needs": "تعيين كلمة المرور أو إزالتها يتطلب صلاحية «إدارة الأسرار».",
      "dialogBody": "اكتب كلمة مرور مستخدم خادم البريد. تُرسل مرة واحدة وتُحفظ مشفّرة ولا تظهر مرة أخرى.",
      "removeTitle": "إزالة كلمة مرور خادم البريد؟",
      "removeBody": "لن تُرسل الرسائل عبر خادمك حتى تُعيَّن كلمة مرور من جديد.",
      "toast": {
        "set": "عُيّنت كلمة مرور خادم البريد",
        "replaced": "استُبدلت كلمة مرور خادم البريد",
        "removed": "أُزيلت كلمة مرور خادم البريد"
      }
    },
    "residency": {
      "title": "بياناتك محفوظة في عُمان",
      "body": "لا يجوز إرسال البريد إلا عبر خدمة بريد معتمدة لحفظ البيانات في عُمان.",
      "approve": "خادم البريد هذا معتمد لحفظ البيانات في عُمان",
      "approveHint": "اختره فقط إن كان الخادم مستضافًا في عُمان أو كان اتفاقك يسمح بذلك.",
      "notAllowed": "غير مسموح به وفق موقع حفظ بيانات شركتك. اختر خدمة أخرى أو أكّد أن الخادم معتمد."
    },
    "test": {
      "title": "رسالة تجريبية",
      "body": "أرسل رسالة قصيرة إلى نفسك للتأكد من أن الإرسال يعمل. تستخدم الإعدادات المحفوظة.",
      "to": "إليك على",
      "language": "اللغة",
      "send": "إرسال رسالة تجريبية",
      "sendAgain": "إرسال رسالة أخرى",
      "notReady": "اضبط إرسال البريد أولًا.",
      "dirty": "احفظ تغييراتك أولًا: الرسالة التجريبية تستخدم الإعدادات المحفوظة.",
      "QUEUED": "في الانتظار. ستُرسل بعد لحظات…",
      "SENDING": "جارٍ الإرسال…",
      "SENT": "أُرسلت.",
      "FAILED": "لم تُرسل.",
      "SUPPRESSED": "لم تُرسل.",
      "sent": "أُرسلت إلى {{address}} في {{time}}. راجع بريدك الوارد، ومجلد الرسائل غير المرغوب فيها إن لم تجدها.",
      "stillQueued": "ما زالت في الانتظار. قد يستغرق الإرسال بضع دقائق.",
      "refresh": "تحديث",
      "openOutbox": "فتح صندوق الصادر",
      "failedPrefix": "لم تُرسل:"
    },
    "whatsappLater": "واتساب: متاح في إصدار لاحق"
  },
  "mappingImpact": {
    "title_zero": "تغيير ربط الحسابات؟",
    "title_one": "تغيير ربط حساب واحد؟",
    "title_two": "تغيير ربط حسابين؟",
    "title_few": "تغيير ربط {{n}} حسابات؟",
    "title_many": "تغيير ربط {{n}} حسابًا؟",
    "title_other": "تغيير ربط {{n}} حساب؟",
    "future": "تُرحَّل القيود القادمة إلى الحساب الجديد.",
    "balances": "تبقى الأرصدة الموجودة في الحساب القديم فيه؛ انقلها بقيد يومية عند الحاجة.",
    "confirm": "تغيير ربط الحسابات"
  },
  "modules": {
    "crm": {
      "description": "العملاء ومجموعاتهم."
    },
    "sales": {
      "description": "عروض الأسعار والفواتير والإشعارات الدائنة وسندات القبض والمبالغ المستردة والذمم المدينة، مع أرصدة العملاء وكشوف حساباتهم."
    },
    "pos": {
      "description": "شاشة البيع والورديات ومبيعات نقاط البيع."
    },
    "purchasing": {
      "description": "الموردون وفواتير الشراء ومدفوعات الموردين والمرتجعات والذمم الدائنة."
    },
    "catalog": {
      "description": "المنتجات والأصناف والفئات والوحدات والخصائص."
    },
    "inventory": {
      "description": "المستودعات وأرصدة المخزون وحركاته وتسوياته وتحويلاته."
    },
    "accounting": {
      "description": "دفتر الأستاذ والقيود اليومية والسنوات المالية وتاريخ الإقفال، والتحويلات بين النقدية والبنوك ومطابقتها، والتقارير المالية."
    },
    "expenses": {
      "description": "المصروفات وفئاتها."
    },
    "workflows": {
      "description": "مسارات اعتماد قابلة للتهيئة للمستندات (المشتريات حاليًا)، وشاشة موافقاتي، والتفويض، ومتابعة طلبات الاعتماد."
    },
    "tasks": {
      "description": "المهام مع الفرق والمسؤولين والمواعيد والمراجعة؛ وأعمالي وإشعارات المهام."
    },
    "service": {
      "description": "أوامر الخدمة وزيارات الفرق وموافقات الأسعار وفوترة الأعمال المنجزة والتحصيلات التي يتحقق منها المحاسب."
    },
    "projects": {
      "description": "المشاريع بخططها وفرقها وموازناتها، وتكاليفها من المشتريات والمصروفات والمخزون، وفوترتها عبر المبيعات، وأعمال المقاولات (جدول الكميات والمستخلصات والمحتجزات) والمؤشرات الذكية."
    },
    "ai": {
      "description": "المساعد الذكي بمفتاح OpenAI الخاص بالشركة: أسئلة عن المشروع ومسودات تقارير الحالة والشرح وتقسيم الخطة. لا يتغير شيء دون نقرة منك."
    },
    "loyalty": {
      "description": "نقاط الولاء: يكسب الأعضاء نقاطًا على مشترياتهم ويستبدلونها في نقطة البيع ويرتقون في المستويات وتنتهي صلاحية النقاط، مع قواعد المكافآت والتعديلات اليدوية وتقرير النقاط."
    },
    "contracts": {
      "description": "عقود الصيانة: ما يُغطّى في مواقع كل عميل وبأي شروط، والزيارات الوقائية، وقوائم فحص كل معدّة، وأقساط العقد."
    },
    "hr": {
      "description": "الموارد البشرية: ملف الموظف وفق قانون العمل العماني، والعقود، والرواتب المكوّنة من عناصر الراتب، والوثائق وتواريخ انتهائها، وسجل الحالات."
    },
    "payroll": {
      "description": "الرواتب: كشوف شهرية على ملف الموظفين مع اشتراكات صندوق الحماية الاجتماعية، ومكافأة نهاية الخدمة، وقسائم الرواتب، وقيد الرواتب، وملف حماية الأجور."
    }
  },
  "modulesList": {
    "on": "مفعّلة",
    "off": "غير مفعّلة"
  },
  "regional": {
    "dates": "التواريخ",
    "datesBody": "تُكتب باسم الشهر، فلا يمكن أن تُقرأ خطأً.",
    "digits": "الأرقام",
    "digitsBody": "أرقام لاتينية في الإنجليزية والعربية، كما تكتب الشركات العُمانية المبالغ.",
    "currency": "العملة",
    "currencyName": "الريال العُماني (<rial/>)، بثلاث خانات عشرية:",
    "currencyBody": "يُحتفظ بكل مبلغ حتى البيسة.",
    "hijri": "التاريخ الهجري",
    "hijriBody": "تقويم أم القرى. في المستندات المطبوعة: {{mode}} (يُغيَّر من الطباعة).",
    "timeZone": "المنطقة الزمنية",
    "timeZoneBody": "تتبع أيام العمل وتواريخ المستندات توقيت مسقط.",
    "language": "اللغة",
    "languageBody": "يختار كل شخص العربية أو الإنجليزية لنفسه؛ وتُطبع المستندات بلغة من يطبعها، مع اللغة الأخرى إلى جانبها."
  },
  "system": {
    "version": "إصدار التطبيق",
    "environment": "البيئة",
    "production": "بيئة التشغيل",
    "development": "بيئة التطوير",
    "support": "الدعم",
    "supportBody": "للمساعدة في حسابك أو وحداتك أو في مشكلة داخل التطبيق، تواصل مع مزوّد خدمة سحاب لديكم واذكر إصدار التطبيق أعلاه."
  },
  "appearance": {
    "reset": "استعادة الإعدادات الافتراضية",
    "resetDone": "تمت استعادة المظهر الافتراضي",
    "scope": "هذه الاختيارات تظهر لك وحدك وعلى هذا المتصفح فقط. المستندات المطبوعة والمشتركة تحتفظ بمظهر ورق الشركة.",
    "style": {
      "title": "النمط",
      "body": "الشكل العام للتطبيق.",
      "modern": {
        "label": "عصري",
        "body": "شريط جانبي داكن وصفحات بلون الورق ولوحات بيضاء واضحة: المظهر الأنيق لتطبيقات كلاود تك."
      },
      "nimbus": {
        "label": "سحابي",
        "body": "زجاج شفاف فوق سحب تنساب ببطء، مع لون تمييز متوهج."
      },
      "ledger": {
        "label": "الدفتر الكلاسيكي",
        "body": "أسطح ورقية مسطحة وخطوط مسطّرة، بهدوء دفتر الحسابات."
      }
    },
    "mode": {
      "title": "فاتح أو داكن",
      "body": "خيار «حسب النظام» يتبع إعداد جهازك.",
      "light": "فاتح",
      "dark": "داكن",
      "system": "حسب النظام"
    },
    "accent": {
      "title": "لون التمييز",
      "body": "يُستخدم للأزرار الرئيسية والروابط والتركيز والصفحة الحالية.",
      "jade": "يشمي",
      "stamp": "حبر الختم",
      "sky": "سماوي",
      "teal": "فيروزي الخليج",
      "saffron": "زعفراني",
      "rose": "وردي",
      "violet": "بنفسجي"
    },
    "corners": {
      "title": "الزوايا",
      "body": "مدى استدارة الأزرار والحقول واللوحات.",
      "sharp": "حادة",
      "soft": "ناعمة",
      "round": "مستديرة"
    },
    "density": {
      "title": "صفوف الجداول",
      "body": "المضغوط يعرض صفوفًا أكثر، والمريح أسهل في القراءة.",
      "compact": "مضغوط",
      "comfortable": "مريح"
    },
    "ambient": {
      "title": "خلفية متحركة",
      "body": "تنساب السحب خلف القائمة ببطء. أوقفها لخلفية ثابتة.",
      "nimbusOnly": "متاح مع النمط السحابي.",
      "label": "السماح للسحب بالانسياب"
    }
  },
  "teams": {
    "views": "طرق عرض الفرق",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "new": "فريق جديد",
    "listLabel": "الفرق",
    "lead": "قائد",
    "memberCount_zero": "لا أعضاء",
    "memberCount_one": "عضو واحد",
    "memberCount_two": "عضوان",
    "memberCount_few": "{{n}} أعضاء",
    "memberCount_many": "{{n}} عضوًا",
    "memberCount_other": "{{n}} عضو",
    "noMembers": "لا أعضاء بعد.",
    "openWorkspace": "فتح مساحة عمل الفريق",
    "editNamed": "تعديل {{name}}",
    "archiveNamed": "أرشفة {{name}}",
    "restoreNamed": "استعادة {{name}}",
    "empty": {
      "title": "لا توجد فرق بعد",
      "body": "أنشئ فريقًا وأضف أعضاءه واختر قادته. تُسند المهام وزيارات الخدمة بعد ذلك إلى الفرق.",
      "archived": "لا توجد فرق مؤرشفة."
    }
  },
  "outbox": {
    "intro": "كل رسالة أرسلها النظام أو حاول إرسالها، الأحدث أولًا. تظهر العناوين مخفية جزئيًا.",
    "tabsLabel": "الرسائل حسب الحالة",
    "tabs": {
      "all": "الكل",
      "FAILED": "تعذّر إرسالها",
      "QUEUED": "في الانتظار",
      "SUPPRESSED": "محجوبة"
    },
    "searchLabel": "البحث في الرسائل",
    "searchPlaceholder": "ابحث بالمستلم أو القالب",
    "clearSearch": "مسح البحث",
    "tableLabel": "الرسائل",
    "columns": {
      "when": "أُنشئت",
      "message": "الرسالة",
      "recipient": "المستلم",
      "record": "السجل",
      "status": "الحالة"
    },
    "status": {
      "QUEUED": "في الانتظار",
      "SENDING": "قيد الإرسال",
      "SENT": "أُرسلت",
      "FAILED": "تعذّر الإرسال",
      "SUPPRESSED": "محجوبة"
    },
    "locale": {
      "en": "بالإنجليزية",
      "ar": "بالعربية"
    },
    "recipientRemoved": "أُزيل العنوان",
    "attempts_one": "محاولة واحدة",
    "attempts_other": "{{count}} محاولة",
    "empty": "لم تُرسل أي رسالة بعد",
    "emptyBody": "تظهر الرسائل هنا عندما يرسل النظام رسالة، مثل فاتورة أو رسالة تجريبية.",
    "emptyFiltered": "لا توجد رسائل تطابق عوامل التصفية هذه.",
    "rowActions": "إجراءات الرسالة",
    "retry": "إعادة الإرسال",
    "retryTitle": "إعادة إرسال هذه الرسالة؟",
    "retryBody": "تعود إلى قائمة الانتظار وتُرسل إلى {{recipient}} بالمحتوى نفسه.",
    "toast": {
      "retried": "أُعيدت الرسالة إلى قائمة الانتظار"
    },
    "attempts_zero": "لا محاولات",
    "attempts_two": "محاولتان",
    "attempts_few": "{{count}} محاولات",
    "attempts_many": "{{count}} محاولة",
    "clearFilters": "مسح عوامل التصفية"
  },
  "templates": {
    "intro": "الرسائل التي يرسلها النظام نيابةً عنك، بالعربية والإنجليزية. غيّر صياغتها لتناسب شركتك.",
    "tableLabel": "قوالب الرسائل",
    "empty": "لا توجد قوالب رسائل بعد",
    "columns": {
      "template": "القالب",
      "kind": "النوع",
      "state": "الصياغة",
      "changed": "آخر تغيير"
    },
    "category": {
      "TRANSACTIONAL": "رسالة خدمة",
      "MARKETING": "تسويق",
      "NURTURE": "متابعة"
    },
    "state": {
      "default": "الافتراضية",
      "customised": "مخصّصة",
      "attention": "تحتاج إلى مراجعة",
      "unsaved": "غير محفوظة"
    },
    "missingCount_one": "متغير واحد غير مستخدم",
    "missingCount_other": "{{count}} متغير غير مستخدم",
    "back": "كل القوالب",
    "editorIntro": "عدّل الموضوع والنص باللغتين. المتغيرات بين الأقواس المزدوجة تُملأ عند إرسال الرسالة.",
    "language": {
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "subject": "الموضوع",
    "body": "النص",
    "bodyHint": "اترك سطرًا فارغًا بين الفقرات.",
    "variables": "المتغيرات",
    "variablesHint": "أدرج متغيرًا حيث كان المؤشر في الموضوع أو النص.",
    "insert": "إدراج {{name}}",
    "inserted": "أُدرج {{name}}",
    "preview": "معاينة بقيم تجريبية",
    "unknownTitle": "احذف المتغيرات التي لا تتوفر لهذه الرسالة",
    "unknownItem": "تستخدم {{language}}",
    "missingTitle": "بعض المتغيرات غير مستخدمة",
    "missingItem": "لا تستخدم {{language}}",
    "blockedUnknown": "احذف المتغيرات غير المعروفة لتتمكن من الحفظ.",
    "blockedEmpty": "كل لغة تحتاج إلى موضوع ونص.",
    "unsaved": "تغييرات غير محفوظة: {{languages}}",
    "allSaved": "حُفظت كل التغييرات",
    "discard": "تجاهل",
    "save": "حفظ القالب",
    "reset": "استعادة الافتراضي",
    "resetTitle": "استعادة النص الافتراضي باللغة {{language}}؟",
    "resetBody": "تُستبدل صياغتك بالنص المرفق مع النظام. تبقى النسخ السابقة في السجل.",
    "staleTitle": "غيّر شخص آخر هذا القالب",
    "staleBody": "تغييراتك باقية هنا. انسخها، ثم عُد إلى القائمة وافتح القالب من جديد لترى أحدث نص.",
    "toast": {
      "saved": "حُفظ القالب",
      "reset": "استُعيد النص الافتراضي باللغة {{language}}"
    },
    "missingCount_zero": "لا متغيرات غير مستخدمة",
    "missingCount_two": "متغيران غير مستخدمين",
    "missingCount_few": "{{count}} متغيرات غير مستخدمة",
    "missingCount_many": "{{count}} متغيرًا غير مستخدم"
  },
  "ai": {
    "usageLink": "الاستخدام والطلبات",
    "available": "متاح",
    "unavailable": "غير متاح",
    "save": "حفظ إعدادات المساعد الذكي",
    "toast": {
      "saved": "حُفظت إعدادات المساعد الذكي"
    },
    "blocked": {
      "disabled": {
        "title": "أوقفه مزوّد خدمة سحاب لديكم",
        "body": "أوقف مزوّد خدمة سحاب لديكم المساعد، ولا يشغّله غيره."
      },
      "module_off": {
        "title": "وحدة المساعد الذكي متوقفة",
        "body": "يشغّل مزوّد خدمة سحاب لديكم الوحدة لشركتك. تواصل معه إن أردت استخدامها."
      },
      "no_policy": {
        "title": "لا توجد سياسة للمساعد لشركتك بعد",
        "body": "يحدّد مزوّد خدمة سحاب لديكم السقف الشهري من الوحدات النصية (tokens) والنماذج من لوحة التحكم. اطلب منه ضبطها."
      },
      "suspended": {
        "title": "أوقفه مزوّد خدمة سحاب لديكم مؤقتًا",
        "body": "أوقف مزوّد خدمة سحاب لديكم المساعد لشركتك. تواصل معه لمعرفة السبب وموعد استئنافه."
      },
      "not_enabled": {
        "title": "المساعد متوقف",
        "body": "شغّله من الأسفل. ستقرأ أولًا ما يُرسَل إلى OpenAI وتوافق عليه."
      },
      "no_key": {
        "title": "لا يوجد مفتاح OpenAI",
        "body": "اضبط مفتاح OpenAI الخاص بشركتك في الأسفل؛ فالمساعد يعمل عبر حساب شركتك في OpenAI."
      },
      "residency": {
        "title": "بانتظار موافقة إقامة البيانات",
        "body": "تُحفظ بيانات شركتك في عُمان. وافق في الأسفل على إرسالها إلى OpenAI خارج عُمان، أو أبقِ المساعد متوقفًا."
      },
      "not_allowed": {
        "title": "غير مسموح لهذا الحساب",
        "body": "لا تُشغّل الجلسات المنتحَلة وحسابات النظام المساعدَ أبدًا."
      }
    },
    "enabled": {
      "title": "المساعد",
      "body": "عند تشغيله، يستطيع من لديهم صلاحية «استخدام المساعد الذكي» استخدامه على السجلات التي يمكنهم فتحها أصلًا.",
      "label": "تشغيل المساعد الذكي"
    },
    "ack": {
      "title": "قبل تشغيل المساعد الذكي",
      "intro": "اقرأ ما يرسله المساعد وتحت أي حساب. توافق شركتك على ذلك مرة واحدة.",
      "points": {
        "sent": {
          "title": "ما يُرسَل إلى OpenAI",
          "body": "الأسئلة التي يطرحها المستخدمون، وما يقرؤه المساعد للإجابة عنها: رموز السجلات وأسماؤها وحالاتها وتواريخها ومبالغها. ولا تُرسَل بيانات الاتصال أو العناوين أو أرقام الهوية أو المرفقات أو الملاحظات عن الأشخاص."
        },
        "account": {
          "title": "تحت أي حساب",
          "body": "يُرسَل كل شيء عبر حساب شركتك ومفتاحها في OpenAI، وفق الشروط المبرمة بين شركتك وشركة OpenAI."
        },
        "controls": {
          "title": "ما يجب ضبطه في OpenAI",
          "body": "اضبط حدًّا شهريًّا للإنفاق وإعدادات التحكم في البيانات (مدة احتفاظ OpenAI بها وهل يجوز لها استخدامها) في حساب OpenAI الخاص بشركتك."
        },
        "clicks": {
          "title": "لا شيء يتغيّر دون نقرة",
          "body": "المساعد يقرأ فقط، وأي تغيير يقترحه لا يُنفَّذ إلا بعد أن يؤكده المستخدم."
        },
        "recorded": {
          "title": "يُسجَّل",
          "body": "تُسجَّل موافقتك مع اسمك ووقتها."
        }
      },
      "version": "الإصدار {{version}} من الإقرار",
      "accept": "الموافقة والتشغيل",
      "close": "إغلاق",
      "pending": "تمت الموافقة. يعمل المساعد عند الحفظ.",
      "accepted": "تمت الموافقة في {{date}} (الإصدار {{version}})",
      "acceptedBy": "وافق {{name}} في {{date}} (الإصدار {{version}})",
      "acceptedByYou": "وافقتَ في {{date}} (الإصدار {{version}})",
      "read": "قراءته مرة أخرى",
      "newVersion": "تغيّر نص الإقرار منذ ذلك الحين. عند تشغيل المساعد مجددًا سيُطلب منك الموافقة عليه أولًا."
    },
    "docAck": {
      "title": "قبل تشغيل ميزة تقرأ المستندات",
      "intro": "الميزة التي تقرأ المستندات ترسل أكثر مما يرسله باقي المساعد. توافق شركتك على ذلك مرة واحدة، قبل تشغيل أول ميزة من هذا النوع.",
      "sentBody": "الأسئلة التي يطرحها المستخدمون، وما يقرؤه المساعد للإجابة عنها: رموز السجلات وأسماؤها وحالاتها وتواريخها ومبالغها. ولا تُرسَل بيانات الاتصال أو العناوين أو أرقام الهوية أو المرفقات أو الملاحظات عن الأشخاص، إلا في الميزات التي تقرأ المستندات، وهي تذكر ذلك تحت علامة اختيارها.",
      "documentsTitle": "المستندات التي يقرؤها",
      "documentsBody": "الميزة التي تقرأ المستندات، مثل تعبئة فاتورة شراء من فاتورة المورد، ترسل ما يُعطى لها: يُرسَل المستند كاملًا إلى OpenAI بكل ما عليه، بما في ذلك الأسماء والعناوين وأرقام الهواتف والأرقام الضريبية. لا يحتفظ سحاب بشيء من المستند نفسه بعد قراءته، أما ما يكتبه المستخدمون معه فيبقى في سجل المساعد طوال مدة الاحتفاظ، كأي سؤال، وكذلك ما يقرؤه المساعد في كل صفحة من مستند أُرسل في لوحته (بنوده وأرقامه وأسماؤه)، ليستمر العمل.",
      "accept": "الموافقة وتحديدها",
      "required": "تشغيل ميزة تقرأ المستندات يتطلب الموافقة على إقرار المستندات أولًا."
    },
    "key": {
      "title": "مفتاح OpenAI الخاص بالشركة",
      "body": "يعمل المساعد عبر حساب شركتك في OpenAI. يُحفظ المفتاح مشفّرًا ولا يُعرض مرة أخرى، حتى لك.",
      "set": "مضبوط",
      "setOn": "ضُبط في {{date}}",
      "notSet": "غير مضبوط",
      "setAction": "ضبط المفتاح",
      "replace": "استبدال المفتاح",
      "remove": "إزالة المفتاح",
      "check": "فحص المفتاح",
      "checkOk": "المفتاح يعمل. النماذج التي يمكنه استخدامها:",
      "checkNoModels": "المفتاح يعمل، لكنه لا يستطيع استخدام أي من النماذج المسموح بها هنا. تحقّق من صلاحيات النماذج للمفتاح في حساب OpenAI.",
      "spendLimit": "اضبط حدًّا شهريًّا للإنفاق وإعدادات التحكم في البيانات لهذا المفتاح في حساب OpenAI الخاص بشركتك.",
      "setTitle": "ضبط مفتاح OpenAI",
      "replaceTitle": "استبدال مفتاح OpenAI",
      "dialogBody": "الصق مفتاحًا من حساب شركتك في OpenAI. يُرسَل مرة واحدة ويُحفظ مشفّرًا ولا يُعرض مرة أخرى.",
      "removeTitle": "إزالة مفتاح OpenAI؟",
      "removeBody": "يتوقف المساعد لدى الجميع حتى يُضبط مفتاح من جديد.",
      "toast": {
        "set": "ضُبط مفتاح OpenAI",
        "replaced": "استُبدل مفتاح OpenAI",
        "removed": "أُزيل مفتاح OpenAI"
      }
    },
    "model": {
      "title": "النموذج",
      "body": "نموذج OpenAI الذي يستخدمه المساعد. يحدّد مزوّد خدمة سحاب لديكم النماذج المسموح بها.",
      "label": "النموذج",
      "hint": "الافتراضي: أول نموذج مسموح به.",
      "default": "الافتراضي ({{model}})",
      "none": "لا يوجد نموذج مسموح به بعد. يختار مزوّد خدمة سحاب لديكم النماذج التي يمكن للمساعد استخدامها.",
      "gone": "{{model}} (لم يعد مسموحًا)",
      "goneBody": "لم يعد {{model}} مسموحًا. يستخدم المساعد {{fallback}} حتى تختار نموذجًا آخر.",
      "notAllowed": "هذا النموذج غير مسموح لشركتك. اختر نموذجًا من القائمة."
    },
    "limits": {
      "title": "الحدود",
      "body": "تحمي فاتورة شركتك لدى OpenAI، ويُرفض الطلب الذي يتجاوز الحد الشهري.",
      "monthly": "الحد الشهري من الوحدات النصية (tokens)",
      "monthlyHint": "{{cap}} على الأكثر، وهو السقف الذي حدّده مزوّد خدمة سحاب لديكم. اتركه فارغًا ليُطبَّق هذا السقف.",
      "monthlyHintNoCap": "لم يحدّد مزوّد خدمة سحاب لديكم سقفًا بعد. اتركه فارغًا إن لم ترد حدًّا خاصًّا بشركتك.",
      "tokensUnit": "وحدة نصية شهريًّا",
      "daily": "الطلبات لكل مستخدم يوميًّا",
      "dailyHint": "من 1 إلى 500. يُحسب كل سؤال أو مسودة أو شرح طلبًا واحدًا.",
      "runsUnit": "يوميًّا",
      "invalidTokens": "أدخل عددًا صحيحًا من الوحدات النصية",
      "invalidDaily": "أدخل عددًا صحيحًا من 1 إلى 500",
      "aboveCap": "{{cap}} وحدة نصية شهريًّا على الأكثر، وهو السقف الذي حدّده مزوّد خدمة سحاب لديكم",
      "aboveCapUnknown": "أعلى من السقف الذي حدّده مزوّد خدمة سحاب لديكم",
      "tokensExplained": "الوحدة النصية (token) تعادل نحو ¾ كلمة إنجليزية (وأقل من ذلك في العربية)؛ ويستهلك السؤال المعتاد بين 5,000 و15,000 وحدة نصية. ويعرض حسابك في OpenAI تكلفتها."
    },
    "features": {
      "title": "الميزات",
      "body": "يمكن تشغيل كل ميزة أو إيقافها، ويظل المستخدم بحاجة إلى صلاحيته المعتادة على السجل.",
      "assistant": {
        "ask": {
          "label": "المساعد في كل صفحة",
          "body": "زر «المساعد» في الشريط العلوي لكل صفحة عدا شاشة البيع. يبحث في المبيعات والعملاء والموردين والمشتريات والمصروفات والمنتجات، ويشغّل تقارير المبيعات والمشتريات، ويفتح الصفحات، ويجيب من المخزون والدفاتر ومواقع الخدمة حيث ميزة «اسأل» الخاصة بها مفعّلة هنا، دائمًا بقدر ما يحق لكل شخص الاطلاع عليه. وتبقى التغييرات بطاقات يؤكّدها أحدهم."
        }
      },
      "projects": {
        "ask": {
          "label": "الأسئلة عن المشروع",
          "body": "يطرح المستخدمون أسئلة عن مشروع يستطيعون فتحه. يقرأ المساعد أرقامه وقد يقترح تغييرًا لا يُنفَّذ إلا بعد تأكيدهم."
        },
        "status_draft": {
          "label": "مسودة تقرير الحالة الأسبوعي",
          "body": "يكتب مسودة الأقسام الأربعة لتقرير المشروع الأسبوعي من سجل الأسبوع، ويضع على الأرقام التي لا يجد لها مصدرًا علامة «غير مؤكَّد»."
        },
        "explain_signal": {
          "label": "شرح التنبيه",
          "body": "يشرح بكلمات بسيطة سبب ظهور تنبيه المشروع، ويقترح حتى ثلاث خطوات تالية."
        },
        "plan": {
          "label": "تقسيم نطاق العمل إلى مراحل",
          "body": "يحوّل وصف النطاق إلى مراحل ومعالم ومهام يعدّلها المستخدم قبل إضافتها إلى الخطة."
        },
        "boq_mapping": {
          "label": "مطابقة أعمدة استيراد جدول الكميات",
          "body": "يقترح الحقل المقابل لكل عمود في ملف جدول الكميات، ولا يُرسَل إلا صف العناوين وأول خمسة صفوف."
        }
      },
      "accounting": {
        "ask": {
          "label": "الأسئلة عن الدفاتر",
          "body": "«اسأل المساعد» في التقارير ودليل الحسابات والقيود وسلامة الدفاتر: إجابات بروابط، وجداول يمكن نسخها بصيغة CSV."
        },
        "explain": {
          "label": "شرح أرقام التقارير",
          "body": "الرمز ✦ على سطر التقرير: أكبر حركات الرقم من الدفاتر أولًا، ثم شرح المساعد."
        },
        "review": {
          "label": "مراجعة سلامة الدفاتر",
          "body": "«راجِع مع المساعد» في سلامة الدفاتر: شرح نتائج فحص الشهر وترتيبها، مع مقترحات مهام واستبعاد في بطاقات."
        },
        "coding": {
          "label": "اقتراح التصنيف",
          "body": "يقترح فئة المصروف الجديد لمستفيد جديد (المستفيد المعروف يكفيه سجله دون المساعد)، ومطابقات أو تسويات لسطور كشف البنك."
        },
        "setup": {
          "label": "اقتراح الإعداد",
          "body": "«اقتراح…» في فئات المصروفات ودليل الحسابات وربط الحسابات: فئات وحسابات وربط في بطاقات تؤكّد كلًا منها على حدة."
        },
        "commentary": {
          "label": "صياغة تعليق الإدارة",
          "body": "«صياغة تعليق الإدارة» في الأرباح والخسائر: تعليق شهري من الدفاتر، مع وسم الأرقام التي لا يضمنها بـ«غير مؤكَّد»."
        }
      },
      "inventory": {
        "ask": {
          "label": "الأسئلة عن المخزون",
          "body": "«اسأل المساعد» في أرصدة المخزون وحركاته وتسوياته وتحويلاته والمستودعات وتقارير المخزون: إجابات بروابط، وجداول يمكن نسخها بصيغة CSV."
        },
        "explain": {
          "label": "شرح منتج",
          "body": "الرمز ✦ على صف المخزون: أرقام المنتج من سجلات المخزون أولًا، ثم شرح المساعد لما حرّك كميته وتكلفته. عند إيقافها تبقى الأرقام متاحة على الصف باسم «مؤشرات المخزون»."
        },
        "review": {
          "label": "مراجعة المخزون",
          "body": "«راجِع المخزون» في أرصدة المخزون: ترتيب فحوص المخزون، مع مقترحات مهام ومسودات تحويل وحدود إعادة طلب في بطاقات."
        },
        "reorder": {
          "label": "اقتراح إعادة الطلب",
          "body": "«اقترح إعادة الطلب» في نواقص المخزون وأرصدة المخزون: ما يُشترى وبأي كمية، مع مسودة فاتورة شراء لكل مورد أو مسودة تحويل في بطاقات. لا يُطلب شيء ولا يُنقل حتى يرحّل أحدهم المسودة."
        }
      },
      "purchasing": {
        "capture": {
          "label": "تعبئة فاتورة شراء من قائمة أو مستند",
          "body": "«تعبئة من قائمة أو مستند» في فاتورة شراء جديدة: يقرأ المساعد قائمة مكتوبة، أو صورًا أو ملف PDF لفاتورة المورد، ويملأ النموذج ليراجعه المستخدم ويحفظه. يُرسَل المستند كاملًا إلى OpenAI بكل ما هو مكتوب عليه، بما في ذلك عنوان المورد وهاتفه ورقمه الضريبي. لا يُحتفَظ بالمستند؛ أما ما يكتبه المستخدم فيبقى في سجل المساعد طوال مدة الاحتفاظ، والنسخة التي تُرفَق عند الحفظ تبقى مع فاتورة الشراء."
        }
      },
      "service": {
        "ask": {
          "label": "تجهيز المواقع بالسؤال",
          "body": "«اسأل المساعد» في المواقع والأصول وفي صفحة الموقع: يجيب عن المواقع وأماكنها ومعداتها، ويقترح في بطاقات مواقع جديدة وأماكن تُنشأ ومكانًا يُنسخ ومعدات تُضاف. لا يُضاف شيء حتى يؤكد أحدهم البطاقة. لا تُرسَل أسماء الشاغلين ولا العناوين ولا الهواتف أبدًا."
        },
        "capture": {
          "label": "تعبئة موقع من قائمة أو مستند",
          "body": "«تعبئة من قائمة أو مستند» في صفحة الموقع: يقرأ المساعد قائمة معدات مكتوبة، أو صورًا أو ملف PDF لجدول تسليم أو مسح للموقع، ويفتح معاينة الاستيراد للموقع ليراجعها المستخدم ويطبّقها. يُرسَل المستند كاملًا إلى OpenAI بكل ما هو مكتوب عليه، بما في ذلك أسماء الشاغلين وهواتفهم. لا يُحتفَظ بالمستند؛ أما الملف الذي يكتبه المساعد فيبقى مع الموقع كأي ملف مستورد."
        }
      }
    },
    "retention": {
      "title": "الاحتفاظ",
      "body": "مدة الاحتفاظ بالمحادثات بعد آخر نشاط فيها.",
      "label": "الاحتفاظ بالمحادثات لمدة",
      "hint": "من 1 إلى 365 يومًا.",
      "invalid": "أدخل عددًا صحيحًا من الأيام من 1 إلى 365",
      "purgedTitle": "يُحذف بعد ذلك",
      "purged": "الأسئلة والإجابات وأي مقترحات لا تزال بانتظار قرار.",
      "keptTitle": "يُحتفظ به",
      "kept": "سجل كل طلب (من ومتى وأي ميزة وسجل والنموذج والوحدات النصية والنتيجة) لمدة 24 شهرًا، دون أي نص."
    },
    "residency": {
      "title": "موافقة إقامة البيانات",
      "body": "تُحفظ بيانات شركتك في عُمان، ويرسل المساعد الأسئلة والسجلات التي يقرؤها إلى OpenAI خارج عُمان.",
      "approve": "الموافقة على إرسال هذه البيانات إلى OpenAI خارج عُمان",
      "hint": "تُسجَّل موافقتك مع اسمك ووقت الحفظ.",
      "approved": "تمت الموافقة في {{date}}",
      "approvedBy": "وافق {{name}} في {{date}}",
      "approvedByYou": "وافقتَ في {{date}}"
    },
    "errors": {
      "AI_DISABLED": "أوقف مزوّد خدمة سحاب لديكم المساعد الذكي.",
      "AI_BLOCKED_BY_POLICY": "المساعد الذكي غير متاح لشركتك حاليًا.",
      "AI_KEY_MISSING": "لم يُضبط مفتاح OpenAI الخاص بشركتك. اضبطه من الإعدادات › المساعد الذكي.",
      "AI_ACK_REQUIRED": "وافق على الإقرار لتشغيل المساعد الذكي.",
      "AI_LIMIT_ABOVE_CAP": "الحد الشهري أعلى من السقف الذي حدّده مزوّد خدمة سحاب لديكم.",
      "AI_MODEL_NOT_ALLOWED": "هذا النموذج غير مسموح لشركتك. اختر نموذجًا آخر.",
      "AI_BUDGET_EXCEEDED": "بلغ الاستخدام حدّ الوحدات النصية.",
      "AI_RUN_IN_PROGRESS": "كان للمستخدم نفسه طلب آخر قيد التنفيذ.",
      "AI_RUN_EXPIRED": "لم يُتخذ قرار بشأن المقترحات خلال 24 ساعة.",
      "AI_RESUME_INCOMPATIBLE": "تغيّر المساعد أثناء انتظاره القرار.",
      "AI_NOT_ALLOWED": "لا يمكن لهذا الحساب استخدام المساعد الذكي.",
      "AI_PROVIDER_AUTH": "رفضت OpenAI المفتاح. تحقّق من صحته وأنه مفعّل، أو استبدله.",
      "AI_PROVIDER_UNAVAILABLE": "تعذّر الوصول إلى OpenAI. حاول مرة أخرى بعد دقائق.",
      "AI_PROVIDER_RATE_LIMITED": "تقيّد OpenAI الطلبات على هذا المفتاح. حاول مرة أخرى بعد دقيقة.",
      "AI_TURN_LIMIT": "احتاج المساعد إلى خطوات كثيرة فتوقف.",
      "AI_MODEL_ERROR": "أعاد النموذج نتيجة غير صالحة للاستخدام.",
      "AI_TIMEOUT": "استغرق الطلب وقتًا طويلًا فأُوقف."
    },
    "usage": {
      "title": "الاستخدام والطلبات",
      "intro": "الوحدات النصية (tokens) المستخدمة مقارنة بحدّك الشهري، وكل طلب للمساعد. نعرض من ومتى وكم فقط، ولا نعرض أي سؤال أو إجابة.",
      "month": "الشهر",
      "usedOf": "وحدة نصية مستخدمة من حد {{limit}} ({{percent}})",
      "usedNoLimit": "وحدة نصية مستخدمة. لا يوجد حد شهري.",
      "reserved": "محجوز للطلبات الجارية",
      "reservedHint": "تحجز الطلبات الجارية والمنتظرة لقرارٍ وحداتٍ نصية حتى تنتهي، ثم لا يُحسب إلا ما استُخدم فعلًا.",
      "runs": "الطلبات",
      "meter": "الوحدات النصية المستخدمة هذا الشهر",
      "meterText": "{{used}} من {{limit}} وحدة نصية ({{percent}})",
      "byDay": "الوحدات النصية حسب اليوم",
      "dayByDay": "يومًا بيوم",
      "day": "اليوم",
      "byFeature": "حسب الميزة",
      "feature": "الميزة",
      "byPerson": "حسب المستخدم",
      "person": "المستخدم",
      "runsColumn": "الطلبات",
      "tokensColumn": "الوحدات النصية",
      "noneThisMonth": "لا توجد طلبات هذا الشهر."
    },
    "runs": {
      "title": "الطلبات",
      "intro": "موضوع كل طلب وكيف انتهى. يبقى النص لدى من طرح السؤال وحده.",
      "tableLabel": "طلبات المساعد",
      "filters": {
        "status": "الحالة",
        "allStatuses": "كل الحالات",
        "feature": "الميزة",
        "allFeatures": "كل الميزات",
        "person": "المستخدم",
        "allPeople": "الجميع",
        "chosenPerson": "المستخدم المختار"
      },
      "columns": {
        "started": "البدء",
        "person": "المستخدم",
        "feature": "الميزة والسجل",
        "status": "النتيجة",
        "tokens": "الوحدات النصية",
        "toolCalls": "السجلات المقروءة",
        "model": "النموذج والمدة"
      },
      "status": {
        "RUNNING": "قيد التنفيذ",
        "COMPLETED": "مكتمل",
        "PAUSED": "بانتظار قرار",
        "FAILED": "فشل",
        "CANCELLED": "أُلغي",
        "ABANDONED": "انتهت مهلته",
        "EXPIRED": "انتهت صلاحيته"
      },
      "reserved": "محجوز",
      "inOut": "{{input}} وارد · {{output}} صادر",
      "seconds": "{{n}} ث",
      "minutes": "{{m}} د {{s}} ث",
      "empty": "لا توجد طلبات هذا الشهر",
      "emptyBody": "تظهر الطلبات هنا عندما يبدأ المستخدمون باستخدام المساعد.",
      "emptyFiltered": "لا توجد طلبات تطابق هذه المرشحات",
      "clearFilters": "مسح المرشحات",
      "outcome": {
        "AI_DISABLED": "كان مزوّد خدمة سحاب لديكم قد أوقف المساعد.",
        "AI_BLOCKED_BY_POLICY": "لم يكن المساعد متاحًا للشركة حينها.",
        "AI_KEY_MISSING": "لم يكن مفتاح OpenAI الخاص بالشركة مضبوطًا.",
        "AI_ACK_REQUIRED": "لم يكن الإقرار قد قُبل.",
        "AI_LIMIT_ABOVE_CAP": "كان الحد الشهري أعلى من السقف الذي حدّده مزوّد خدمة سحاب لديكم.",
        "AI_MODEL_NOT_ALLOWED": "لم يكن النموذج مسموحًا للشركة.",
        "AI_BUDGET_EXCEEDED": "كان الاستخدام قد بلغ حدّ الوحدات النصية.",
        "AI_RUN_IN_PROGRESS": "كان للمستخدم نفسه طلب آخر قيد التنفيذ.",
        "AI_RUN_EXPIRED": "لم يُتخذ قرار بشأن المقترحات خلال 24 ساعة.",
        "AI_RESUME_INCOMPATIBLE": "تغيّر المساعد أثناء انتظاره القرار.",
        "AI_NOT_ALLOWED": "لم يكن بإمكان هذا الحساب استخدام المساعد الذكي.",
        "AI_PROVIDER_AUTH": "رفضت OpenAI المفتاح.",
        "AI_PROVIDER_UNAVAILABLE": "تعذّر الوصول إلى OpenAI.",
        "AI_PROVIDER_RATE_LIMITED": "قيّدت OpenAI الطلبات على المفتاح.",
        "AI_TURN_LIMIT": "احتاج المساعد إلى خطوات كثيرة فتوقف.",
        "AI_MODEL_ERROR": "أعاد النموذج نتيجة غير صالحة للاستخدام.",
        "AI_TIMEOUT": "استغرق الطلب وقتًا طويلًا فأُوقف."
      }
    },
    "areas": {
      "title": "ما يساعد فيه المساعد",
      "body": "شغّل المجال أو أوقفه من مفتاحه، ثم اختر ميزاته. تحتاج كل ميزة أيضًا إلى وحدتها.",
      "general": "المساعد في كل صفحة",
      "changes": "يجوز له اقتراح التغييرات اليومية",
      "documents": "يجوز له قراءة الصور وملفات PDF المرسلة في لوحته",
      "documentsBody": "فاتورة مورّد أو طلب عميل، تُقرأ في العمل المطلوب (مسودة شراء أو فاتورة أو عرض سعر) في بطاقة يؤكّدها الشخص. لا تُحفظ الملفات، ويبقى ما قُرئ منها مع المحادثة. تشغيله يطلب منك قبول إقرار المستندات أولًا.",
      "sensitive": "يجوز له أيضًا اقتراح التغييرات الحساسة",
      "sensitiveBody": "ترحيل الفواتير والمشتريات والإشعارات الدائنة وإلغاؤها، وتسجيل المقبوضات ومدفوعات الموردين، والأرشفة، كلٌّ في بطاقة يؤكّدها الشخص ضمن صلاحياته وقواعد الدفاتر (تاريخ الإقفال والموافقات). متوقف حتى تشغّله.",
      "changesBody": "إضافة العملاء والموردين والمنتجات وتعديلها، والأسعار، وتسويات المخزون، ومسودات الفواتير وعروض الأسعار والمشتريات، كلٌّ في بطاقة يؤكّدها الشخص ضمن صلاحياته. لا يُرحَّل شيء ولا يُدفع.",
      "projects": "مساعد المشاريع",
      "accounting": "المساعد المحاسبي",
      "inventory": "مساعد المخزون",
      "purchasing": "مساعد المشتريات",
      "service": "مساعد الخدمة",
      "areaSwitch": "استخدام {{area}}",
      "notAllowed": "غير مسموح من مزوّد خدمة سحاب لديكم",
      "notAllowedBody": "لم يسمح مزوّد خدمة سحاب لديكم بهذا المجال لشركتك. تواصل معه إن احتجت إليه.",
      "countOn": "{{on}} من {{all}} مفعّلة",
      "off": "متوقف",
      "offBody": "هذا المجال متوقف. تحتفظ ميزاته بإشاراتها، فإذا أعدت تشغيله عادت كما كانت.",
      "documentsHint": "تبقى قراءة المستندات متوقفة حتى تحددها هنا.",
      "turnedOn": "مفعّلة منذ {{date}}",
      "turnedOnBy": "شغّلها {{name}} في {{date}}",
      "turnedOnByYou": "شغّلتَها في {{date}}"
    }
  },
  "privacyRules": {
    "rulesTitle": "قواعد الاحتفاظ",
    "runsTitle": "آخر تشغيل للاحتفاظ"
  },
  "typography": {
    "font": {
      "title": "نوع الخط",
      "body": "كل الخطوط تكتب العربية واللاتينية. خط IBM Plex هو خط نظام التصميم.",
      "options": {
        "ibmPlex": "آي بي إم بلكس (الافتراضي)",
        "tajawal": "تجوال",
        "cairo": "القاهرة",
        "almarai": "المراعي",
        "notoSans": "نوتو سانس",
        "readexPro": "ريدكس برو"
      }
    },
    "textSize": {
      "title": "حجم النص",
      "body": "النص الأكبر أسهل في القراءة، والأصغر يعرض المزيد في الشاشة. المسافات والأزرار لا تتغير.",
      "options": {
        "small": {
          "label": "صغير",
          "body": "نص بحجم 13 بكسل: صفوف أكثر في الشاشة."
        },
        "default": {
          "label": "افتراضي",
          "body": "نص بحجم 14 بكسل، كما صُمم."
        },
        "large": {
          "label": "كبير",
          "body": "نص بحجم 15 بكسل."
        },
        "xlarge": {
          "label": "كبير جدًا",
          "body": "نص بحجم 16 بكسل: الأسهل في القراءة."
        }
      }
    },
    "preview": {
      "title": "معاينة",
      "body": "كيف تبدو الشاشة بهذا الاختيار، قبل الحفظ.",
      "heading": "الفواتير",
      "sentence": "على شركة النور للتجارة 1,234.500 عن أكتوبر. أرسل تذكيرًا أو سجّل سند قبض.",
      "customer": "شركة النور للتجارة",
      "caption": "تستحق في 13 نوفمبر 2026 · ضريبة 5%"
    },
    "sampleLatin": "Invoice {{amount}}",
    "sampleArabic": "فاتورة ضريبية · سحاب",
    "save": "حفظ الخطوط والنص",
    "toast": {
      "saved": "حُفظت الخطوط والنص. يراها الجميع عند تحميل الصفحة التالية."
    }
  },
  "commissions": {
    "blocks": {
      "approval": "الاعتماد",
      "payment": "الصرف"
    },
    "makerChecker": {
      "label": "من يحتسب الكشف لا يعتمده",
      "hint": "مبدأ الفصل: يحتاج الاعتماد إلى شخص ثانٍ."
    },
    "payroll": {
      "label": "صرف العمولة المعتمدة في قسيمة الراتب",
      "hint": "مع تفعيل الرواتب يُصرف للموظف المرتبط بالمستحق في قسيمته التالية؛ وإلا فتُصرف العمولة من حساب نقدي أو بنكي."
    },
    "save": "حفظ إعدادات العمولات",
    "toast": {
      "saved": "حُفظت إعدادات العمولات"
    }
  }
}
